import { Injectable } from "@angular/core";
import { AshaEmployeeRecord } from "../classes/domain/entities/website/masters/asha/asha-employee-record/ashaemployeerecord";
import { State } from "../classes/domain/entities/website/masters/state/state";
import { Zone } from "../classes/domain/entities/website/masters/zone/zone";
import { District } from "../classes/domain/entities/website/masters/district/district";
import { Block } from "../classes/domain/entities/website/masters/block/block";
import { PHC } from "../classes/domain/entities/website/masters/phc/phc";
import { SC } from "../classes/domain/entities/website/masters/sc/sc";
import { Village } from "../classes/domain/entities/website/masters/village/village";
import { UIUtils } from "./uiutils.service";
import { AFPostMaster } from "../classes/domain/entities/website/masters/sanctioned-posts/af-post/afpost";
import { DropdownLimits } from "../classes/infrastructure/enums";
import { BehaviorSubject, Observable } from "rxjs";
import { BcmPostMaster } from "../classes/domain/entities/website/masters/sanctioned-posts/bcm-post/bcmpost";
import { BFEmployeeRecord } from "../classes/domain/entities/website/masters/bf/bf-employee-record/bfemployeerecord";
import { BCMEmployeeRecord } from "../classes/domain/entities/website/masters/bcm/bcm-employee-record/bcmemployeerecord";

export class FilterState {
  state_id: number = 0;
  zone_id: number = 0;
  district_id: number = 0;
  block_id: number = 0;
  phc_id: number = 0;
  sc_id: number = 0;
  village_id: number = 0;
  asha_employee_record_id: number = 0;
  af_employee_record_id: number = 0;
  af_post_id: number = 0;
  bcm_post_id: number = 0;
  month: number = 0;
  financial_year_id: number = 0;
  bcm_employee_record_id: number = 0;
}

export class ResponseProps {
  state_id: number = 0;
  zone_id: number = 0;
  district_id: number = 0;
  block_id: number = 0;
  phc_id: number = 0;
  af_post_id: number = 0;
  af_employee_record_id: number = 0;
  sc_id: number = 0;
  village_id: number = 0;
  asha_employee_record_id: number = 0;
  bcm_post_id: number = 0; // ** bcmpost **
  bcm_employee_record_id: number = 0; // ** bcm employee **
}

@Injectable({
  providedIn: "root",
})
export class FilterDataUPTOLevelsService {
  // ✅ Filtered lists (bound to UI)
  StateList: State[] = [];
  ZoneList: Zone[] = [];
  DistrictList: District[] = [];
  BlockList: Block[] = [];
  PHCList: PHC[] = [];
  AFPostList: AFPostMaster[] = [];
  AFEmployeeRecordList: BFEmployeeRecord[] = [];
  SCList: SC[] = [];
  VillageList: Village[] = [];
  AshaEmployeeRecordList: AshaEmployeeRecord[] = [];
  BCMPostList: BcmPostMaster[] = []; // ** bcmpost **
  BCMEmployeeRecordList: BCMEmployeeRecord[] = []; // ** bcmpost **

  // ✅ Original unfiltered lists
  StateLookup: State[] = [];
  ZoneLookup: Zone[] = [];
  DistrictLookup: District[] = [];
  BlockLookup: Block[] = [];
  PHCLookup: PHC[] = [];
  AFPostLookup: AFPostMaster[] = [];
  AFEmployeeLookup: BFEmployeeRecord[] = [];
  SCLookup: SC[] = [];
  VillageLookup: Village[] = [];
  AshaEmployeeRecordLookup: AshaEmployeeRecord[] = [];
  AFEmployeeRecordLookup: BFEmployeeRecord[] = [];
  BCMPostLookup: BcmPostMaster[] = []; // ** bcmpost **
  BCMEmployeeRecordLookup: BCMEmployeeRecord[] = []; // ** bcmpost **

  // ✅ Selected Refs (for binding to component)
  state_id: number = 0;
  zone_id: number = 0;
  district_id: number = 0;
  block_id: number = 0;
  phc_id: number = 0;
  af_post_id: number = 0;
  sc_id: number = 0;
  village_id: number = 0;
  asha_employee_record_id: number = 0;
  af_employee_record_id: number = 0;
  month: number = 0;
  financial_year_id: number = 0;
  bcm_post_id: number = 0; // ** bcmpost **
  bcm_employee_record_id: number = 0;

  // ✅ Disabled states
  IsStateDisabled: boolean = false;
  IsZoneDisabled: boolean = false;
  IsDistrictDisabled: boolean = false;
  IsBlockDisabled: boolean = false;
  IsPHCDisabled: boolean = false;
  IsAFPostDisabled: boolean = false;
  IsSCDisabled: boolean = false;
  IsVillageDisabled: boolean = false;
  IsAshaEmployeeRecordDisabled: boolean = false;
  IsAFEmployeeRecordDisabled: boolean = false;
  IsBCMPostDisabled: boolean = false; // ** bcmpost **
  IsBCMEmployeeRecordDisabled: boolean = false; // ** bcmpost **

  // ✅ Central state management using BehaviorSubject (reactive)
  public filterState$ = new BehaviorSubject<FilterState>(new FilterState());
  public filterStateforcancel$ = new BehaviorSubject<FilterState>(new FilterState());

  // ✅ Expose as Observable for components to subscribe
  public readonly currentFilters$: Observable<FilterState> =
    this.filterState$.asObservable();

  // 🚦 Flag to prevent notifications during initialization
  private isInitializing = false;

  // 🔔 Callback for filter changes
  private filterChangeCallback?: () => void;

  constructor(private uiUtils: UIUtils) {}
  async getHierarchyData(
    UpTO: number,
    errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance()
      .GlobalUIErrorHandler,
  ): Promise<ResponseProps> {
    //Set Current filterState

    this.setFilterState();

    switch (UpTO) {
      case DropdownLimits.UPToZone: // 100
        return await this.LoadFilterDataUPTOZoneLevel(UpTO);

      case DropdownLimits.UPTODistrict: // 200
        return await this.LoadFilterDataUPTODistrictLevel(UpTO);

      case DropdownLimits.UPTOBlock: // 300
        return await this.LoadFilterDataUPTOBlockLevel(UpTO);

      case DropdownLimits.UPTOPHC: // 400
        return await this.LoadFilterDataUPTOPHCLevel(UpTO);

      case DropdownLimits.UPTOAF: // 500
        return await this.LoadFilterDataUPTOAFLevel(UpTO);

      case DropdownLimits.UPTOSC: // 600
      //   return await this.LoadSuperAdminData();

      case DropdownLimits.UPTOVillage: // 700
      //   return await this.LoadSuperAdminData();

      case DropdownLimits.UPTOAsha: // 800
        return await this.LoadFilterDataUPTOAshaLevel(UpTO);

      case DropdownLimits.UPTOBCMPost: // 900
        return await this.LoadFilterDataUPTOBCMProfileLevel(UpTO);

      case DropdownLimits.UPTOAFPost: // 1000
        return await this.LoadFilterDataUPTOAFPostLevel(UpTO);
      default:
        return new ResponseProps();
    }
  }

  // ✅ Load UpTo Asha Data from API
  async LoadFilterDataUPTOZoneLevel(
    UpTO: number,
    errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance()
      .GlobalUIErrorHandler,
  ): Promise<ResponseProps> {
    let response = new ResponseProps();
    console.log("response transaction :", response);
    //  Disable change notifications during data load to prevent cascading API calls
    this.isInitializing = true;

    try {
      // Fetch all Asha records with hierarchy data from API
      var districtData = await Zone.FetchEntireListForTransactionFilter(
        async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
      );
      console.log("`districtData` :", districtData);

      if (districtData.length === 0) {
        await this.uiUtils.showErrorMessage("Error", "No Zone Found");
        return response;
      }

      // Sort Asha Employee Record List alphabetically by name
      this.ZoneLookup = districtData.sort((a, b) =>
        (a.p.name || "").localeCompare(b.p.name || ""),
      );
      this.ZoneList = [...this.ZoneLookup];
      console.log('this.ZoneList :', this.ZoneList);

      //  Extract unique States from Asha data and build State list
      const stateMap = new Map();
      districtData.forEach((asha) => {
        if (asha.p.state_id > 0 && !stateMap.has(asha.p.state_id)) {
          let state = State.CreateNewInstance();
          state.p.id = asha.p.state_id;
          state.p.name_en = asha.p.state_name_en;
          state.p.name_mr = asha.p.state_name_mr;
          stateMap.set(asha.p.state_id, state);
        }
      });
      if (Array.from(stateMap.values()).length > 0) {
        this.StateLookup = Array.from(stateMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log("   this.StateLookup serv:", this.StateLookup);
        this.StateList = [...this.StateLookup];
      }

      //   Auto-select and disable dropdowns with only one option
      if (this.StateLookup.length === 1) {
        this.state_id = this.StateLookup[0].p.id;
        this.IsStateDisabled = true;
      } else {
        this.state_id = this.filterState$.value.state_id;
      }
      if (this.ZoneLookup.length === 1) {
        this.zone_id = this.ZoneLookup[0].p.id;
        this.IsZoneDisabled = true;
      } else {
        this.zone_id = this.filterState$.value.zone_id;
      }

      // ✅ IMPORTANT: Apply filters to populate cascading dropdowns
      this.applyFilters();

      response.state_id = this.state_id;
      response.zone_id = this.zone_id;

      return response;
    } catch (error) {
      await this.uiUtils.showErrorMessage(
        "Error",
        "Failed to load hierarchy data",
      );
      return response;
    } finally {
      //  Re-enable change notifications after 100ms (ensures all UI bindings complete)
      setTimeout(() => {
        this.isInitializing = false;
      }, 100);
    }
  }

  // ✅ Load UpTo Asha Data from API
  async LoadFilterDataUPTODistrictLevel(
    UpTO: number,
    errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance()
      .GlobalUIErrorHandler,
  ): Promise<ResponseProps> {
    let response = new ResponseProps();
    console.log("response transaction :", response);
    //  Disable change notifications during data load to prevent cascading API calls
    this.isInitializing = true;

    try {
      // Fetch all Asha records with hierarchy data from API
      var districtData = await District.FetchEntireListForTransactionFilter(
        async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
      );
      console.log("`districtData` :", districtData);

      if (districtData.length === 0) {
        await this.uiUtils.showErrorMessage("Error", "No District Found");
        return response;
      }

      // Sort Asha Employee Record List alphabetically by name
      this.DistrictLookup = districtData.sort((a, b) =>
        (a.p.name_en || "").localeCompare(b.p.name_en || ""),
      );
      this.DistrictList = [...this.DistrictLookup];

      //  Extract unique States from Asha data and build State list
      const stateMap = new Map();
      districtData.forEach((asha) => {
        if (asha.p.state_id > 0 && !stateMap.has(asha.p.state_id)) {
          let state = State.CreateNewInstance();
          state.p.id = asha.p.state_id;
          state.p.name_en = asha.p.state_name_en;
          state.p.name_mr = asha.p.state_name_mr;
          stateMap.set(asha.p.state_id, state);
        }
      });
      if (Array.from(stateMap.values()).length > 0) {
        this.StateLookup = Array.from(stateMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log("   this.StateLookup serv:", this.StateLookup);
        this.StateList = [...this.StateLookup];
      }

      //  Extract unique Zones from Asha data and build Zone list
      const zoneMap = new Map();
      districtData.forEach((asha) => {
        if (asha.p.zone_id && !zoneMap.has(asha.p.zone_id)) {
          let zone = Zone.CreateNewInstance();
          zone.p.id = asha.p.zone_id;
          zone.p.name = asha.p.zone_name;
          zone.p.state_id = asha.p.state_id;
          zoneMap.set(asha.p.zone_id, zone);
        }
      });
      if (Array.from(zoneMap.values()).length > 0) {
        this.ZoneLookup = Array.from(zoneMap.values()).sort((a, b) =>
          (a.p.Name || "").localeCompare(b.p.Name || ""),
        );
        console.log(" this.ZoneLookup  serv:", this.ZoneLookup);
        this.ZoneList = [...this.ZoneLookup];
        console.log(' this.ZoneList dis:',  this.ZoneList);
      }
      //   Auto-select and disable dropdowns with only one option
      if (this.StateLookup.length === 1) {
        this.state_id = this.StateLookup[0].p.id;
        this.IsStateDisabled = true;
      } else {
        this.state_id = this.filterState$.value.state_id;
      }
      if (this.ZoneLookup.length === 1) {
        this.zone_id = this.ZoneLookup[0].p.id;
        this.IsZoneDisabled = true;
      } else {
        this.zone_id = this.filterState$.value.zone_id;
      }
      if (this.DistrictLookup.length === 1) {
        this.district_id = this.DistrictLookup[0].p.id;
        this.IsDistrictDisabled = true;
      } else {
        this.district_id = this.filterState$.value.district_id;
      }

      // ✅ IMPORTANT: Apply filters to populate cascading dropdowns
      this.applyFilters();

      response.state_id = this.state_id;
      response.zone_id = this.zone_id;
      response.district_id = this.district_id;

      return response;
    } catch (error) {
      await this.uiUtils.showErrorMessage(
        "Error",
        "Failed to load hierarchy data",
      );
      return response;
    } finally {
      //  Re-enable change notifications after 100ms (ensures all UI bindings complete)
      setTimeout(() => {
        this.isInitializing = false;
      }, 100);
    }
  }

  // ✅ Load UpTo Asha Data from API
  async LoadFilterDataUPTOBlockLevel(
    UpTO: number,
    errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance()
      .GlobalUIErrorHandler,
  ): Promise<ResponseProps> {
    let response = new ResponseProps();
    console.log("response transaction :", response);

    //  Disable change notifications during data load to prevent cascading API calls
    this.isInitializing = true;

    try {
      // Fetch all Asha records with hierarchy data from API
      var blockData = await Block.FetchEntireListForTransactionFilter(
        async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
      );
      console.log("`blockData` :", blockData);

      if (blockData.length === 0) {
        await this.uiUtils.showErrorMessage("Error", "No Block Found");
        return response;
      }

      // Sort Asha Employee Record List alphabetically by name
      this.BlockLookup = blockData.sort((a, b) =>
        (a.p.name_en || "").localeCompare(b.p.name_en || ""),
      );
      this.BlockList = [...this.BlockLookup];

      //  Extract unique States from Asha data and build State list
      const stateMap = new Map();
      blockData.forEach((asha) => {
        if (asha.p.state_id > 0 && !stateMap.has(asha.p.state_id)) {
          let state = State.CreateNewInstance();
          state.p.id = asha.p.state_id;
          state.p.name_en = asha.p.state_name_en;
          state.p.name_mr = asha.p.state_name_mr;
          stateMap.set(asha.p.state_id, state);
        }
      });
      if (Array.from(stateMap.values()).length > 0) {
        this.StateLookup = Array.from(stateMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log("   this.StateLookup serv:", this.StateLookup);
        this.StateList = [...this.StateLookup];
      }

      //  Extract unique Zones from Asha data and build Zone list
      const zoneMap = new Map();
      blockData.forEach((asha) => {
        if (asha.p.zone_id && !zoneMap.has(asha.p.zone_id)) {
          let zone = Zone.CreateNewInstance();
          zone.p.id = asha.p.zone_id;
          zone.p.name = asha.p.zone_name;
          zone.p.state_id = asha.p.state_id;
          zoneMap.set(asha.p.zone_id, zone);
        }
      });
      if (Array.from(zoneMap.values()).length > 0) {
        this.ZoneLookup = Array.from(zoneMap.values()).sort((a, b) =>
          (a.p.Name || "").localeCompare(b.p.Name || ""),
        );
        console.log(" this.ZoneLookup  serv:", this.ZoneLookup);
        this.ZoneList = [...this.ZoneLookup];
      }

      //  Extract unique Districts from Asha data and build District list
      const districtMap = new Map();
      blockData.forEach((asha) => {
        if (asha.p.district_id && !districtMap.has(asha.p.district_id)) {
          let district = District.CreateNewInstance();
          district.p.id = asha.p.district_id;
          district.p.name_en = asha.p.district_name_en;
          // district.p.name_mr = asha.p.district_name_mr;
          district.p.zone_id = asha.p.zone_id;
          district.p.state_id = asha.p.state_id;
          districtMap.set(asha.p.district_id, district);
        }
      });
      if (Array.from(districtMap.values()).length > 0) {
        this.DistrictLookup = Array.from(districtMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log("this.DistrictLookup serv :", this.DistrictLookup);
        this.DistrictList = [...this.DistrictLookup];
      }

      //   Auto-select and disable dropdowns with only one option
      if (this.StateLookup.length === 1) {
        this.state_id = this.StateLookup[0].p.id;
        this.IsStateDisabled = true;
      } else {
        this.state_id = this.filterState$.value.state_id;
      }
      if (this.ZoneLookup.length === 1) {
        this.zone_id = this.ZoneLookup[0].p.id;
        this.IsZoneDisabled = true;
      } else {
        this.zone_id = this.filterState$.value.zone_id;
      }
      if (this.DistrictLookup.length === 1) {
        this.district_id = this.DistrictLookup[0].p.id;
        this.IsDistrictDisabled = true;
      } else {
        this.district_id = this.filterState$.value.district_id;
      }
      if (this.BlockLookup.length === 1) {
        this.block_id = this.BlockLookup[0].p.id;
        this.IsBlockDisabled = true;
      } else {
        this.block_id = this.filterState$.value.block_id;
      }

      // ✅ IMPORTANT: Apply filters to populate cascading dropdowns
      this.applyFilters();

      response.state_id = this.state_id;
      response.zone_id = this.zone_id;
      response.district_id = this.district_id;
      response.block_id = this.block_id;

      return response;
    } catch (error) {
      await this.uiUtils.showErrorMessage(
        "Error",
        "Failed to load hierarchy data",
      );
      return response;
    } finally {
      //  Re-enable change notifications after 100ms (ensures all UI bindings complete)
      setTimeout(() => {
        this.isInitializing = false;
      }, 100);
    }
  }

  // ✅ Load Up To BCM Post Data from API
  async LoadFilterDataUPTOBCMProfileLevel(
    UpTO: number,
    errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance()
      .GlobalUIErrorHandler,
  ): Promise<ResponseProps> {
    let response = new ResponseProps();
    console.log("response transaction :", response);

    //  Disable change notifications during data load to prevent cascading API calls
    this.isInitializing = true;

    try {
      // Fetch all bcm records with hierarchy data from API
      var BCMEmployeeData =
        await BcmPostMaster.FetchEntireListForTransactionFilter(
          async (errMsg) =>
            await this.uiUtils.showErrorMessage("Error", errMsg),
        );
      console.log("`BcmPost Name` :", BCMEmployeeData);

      if (BCMEmployeeData.length === 0) {
        await this.uiUtils.showErrorMessage("Error", "No BCM Post Found");
        return response;
      }

      // Sort bcm Employee Record List alphabetically by name
      this.BCMPostLookup = BCMEmployeeData.sort((a, b) =>
        (a.p.full_name || "").localeCompare(b.p.full_name || ""),
      );
      this.BCMPostList = [...this.BCMPostLookup];

      //  Extract unique States from bcm data and build State list
      const stateMap = new Map();
      BCMEmployeeData.forEach((bcm) => {
        if (bcm.p.state_id > 0 && !stateMap.has(bcm.p.state_id)) {
          let state = State.CreateNewInstance();
          state.p.id = bcm.p.state_id;
          state.p.name_en = bcm.p.state_name_en;
          state.p.name_mr = bcm.p.state_name_mr;
          stateMap.set(bcm.p.state_id, state);
        }
      });
      if (Array.from(stateMap.values()).length > 0) {
        this.StateLookup = Array.from(stateMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log(
          "   this.BCMEmployeeData StateLookup serv:",
          this.StateLookup,
        );
        this.StateList = [...this.StateLookup];
      }

      //  Extract unique Zones from bcm data and build Zone list
      const zoneMap = new Map();
      BCMEmployeeData.forEach((bcm) => {
        if (bcm.p.zone_id && !zoneMap.has(bcm.p.zone_id)) {
          let zone = Zone.CreateNewInstance();
          zone.p.id = bcm.p.zone_id;
          zone.p.name = bcm.p.zone_name;
          zone.p.state_id = bcm.p.state_id;
          zoneMap.set(bcm.p.zone_id, zone);
        }
      });
      if (Array.from(zoneMap.values()).length > 0) {
        this.ZoneLookup = Array.from(zoneMap.values()).sort((a, b) =>
          (a.p.Name || "").localeCompare(b.p.Name || ""),
        );
        console.log(" this. BCMEmployeeDataZoneLookup  serv:", this.ZoneLookup);
        this.ZoneList = [...this.ZoneLookup];
      }

      //  Extract unique Districts from bcm data and build District list
      const districtMap = new Map();
      BCMEmployeeData.forEach((bcm) => {
        if (bcm.p.district_id && !districtMap.has(bcm.p.district_id)) {
          let district = District.CreateNewInstance();
          district.p.id = bcm.p.district_id;
          district.p.name_en = bcm.p.district_name_en;
          district.p.name_mr = bcm.p.district_name_mr;
          district.p.zone_id = bcm.p.zone_id;
          district.p.state_id = bcm.p.state_id;
          districtMap.set(bcm.p.district_id, district);
        }
      });
      if (Array.from(districtMap.values()).length > 0) {
        this.DistrictLookup = Array.from(districtMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log(
          "this.BCMEmployeeData DistrictLookup serv :",
          this.DistrictLookup,
        );
        this.DistrictList = [...this.DistrictLookup];
      }

      //  Extract unique Blocks from bcm data and build Block list
      const blockMap = new Map();
      BCMEmployeeData.forEach((bcm) => {
        if (bcm.p.block_id && !blockMap.has(bcm.p.block_id)) {
          let block = Block.CreateNewInstance();
          block.p.id = bcm.p.block_id;
          block.p.name_en = bcm.p.block_name_en;
          block.p.name_mr = bcm.p.block_name_mr;
          block.p.district_id = bcm.p.district_id;
          block.p.zone_id = bcm.p.zone_id;
          block.p.state_id = bcm.p.state_id;
          blockMap.set(bcm.p.block_id, block);
        }
      });
      if (Array.from(blockMap.values()).length > 0) {
        this.BlockLookup = Array.from(blockMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log(" this.BCMEmployeeData BlockLookup :", this.BlockLookup);
        this.BlockList = [...this.BlockLookup];
      }

      //  Extract unique Blocks from bcm data and build Block list
      const blockpostMap = new Map();
      BCMEmployeeData.forEach((bcm) => {
        if (bcm.p.bcm_post_id && !blockpostMap.has(bcm.p.bcm_post_id)) {
          let blockpost = BcmPostMaster.CreateNewInstance();
          blockpost.p.id = bcm.p.bcm_post_id;
          blockpost.p.name = bcm.p.name;
          blockpost.p.block_id = bcm.p.block_id;
          blockpost.p.district_id = bcm.p.district_id;
          blockpost.p.zone_id = bcm.p.zone_id;
          blockpost.p.state_id = bcm.p.state_id;
          blockpostMap.set(bcm.p.bcm_post_id, blockpost);
        }
      });
      if (Array.from(blockpostMap.values()).length > 0) {
        this.BCMPostLookup = Array.from(blockpostMap.values()).sort((a, b) =>
          (a.p.Name || "").localeCompare(b.p.Name || ""),
        );
        console.log(
          " this.BCMEmployeeData BCMPostLookup :",
          this.BCMPostLookup,
        );
        this.BCMPostList = [...this.BCMPostLookup];
      }

      //   Auto-select and disable dropdowns with only one option
      if (this.StateLookup.length === 1) {
        this.state_id = this.StateLookup[0].p.id;
        this.IsStateDisabled = true;
      } else {
        this.state_id = this.filterState$.value.state_id;
      }
      if (this.ZoneLookup.length === 1) {
        this.zone_id = this.ZoneLookup[0].p.id;
        this.IsZoneDisabled = true;
      } else {
        this.zone_id = this.filterState$.value.zone_id;
      }
      if (this.DistrictLookup.length === 1) {
        this.district_id = this.DistrictLookup[0].p.id;
        this.IsDistrictDisabled = true;
      } else {
        this.district_id = this.filterState$.value.district_id;
      }
      if (this.BlockLookup.length === 1) {
        this.block_id = this.BlockLookup[0].p.id;
        this.IsBlockDisabled = true;
      } else {
        this.block_id = this.filterState$.value.block_id;
      }

      // ** bcmpost **

      if (this.BCMPostLookup.length === 1) {
        this.bcm_post_id = this.BCMPostLookup[0].p.id;
        this.IsBCMPostDisabled = true;
      } else {
        this.bcm_post_id = this.filterState$.value.bcm_post_id;
      }

      // ** bcmpost End **

      // ✅ IMPORTANT: Apply filters to populate cascading dropdowns
      this.applyFilters();

      response.state_id = this.state_id;
      response.zone_id = this.zone_id;
      response.district_id = this.district_id;
      response.block_id = this.block_id;
      response.bcm_post_id = this.bcm_post_id; // ** bcmpost **

      return response;
    } catch (error) {
      await this.uiUtils.showErrorMessage(
        "Error",
        "Failed to load hierarchy data",
      );
      return response;
    } finally {
      //  Re-enable change notifications after 100ms (ensures all UI bindings complete)
      setTimeout(() => {
        this.isInitializing = false;
      }, 100);
    }
  }
  // ******** End Code of LoadFilter DataUPTO BCM Post Level  ********8

  // ✅ Load Up To PHC Data from API
  async LoadFilterDataUPTOPHCLevel(
    UpTO: number,
    errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance()
      .GlobalUIErrorHandler,
  ): Promise<ResponseProps> {
    let response = new ResponseProps();
    console.log("response transaction :", response);

    //  Disable change notifications during data load to prevent cascading API calls
    this.isInitializing = true;

    try {
      // Fetch all Asha records with hierarchy data from API
      var PHCData = await PHC.FetchEntireListForReportFilter(
        async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
      );
      console.log("`PHCData` :", PHCData);

      if (PHCData.length === 0) {
        await this.uiUtils.showErrorMessage("Error", "No PHC Found");
        return response;
      }

      // Sort Asha Employee Record List alphabetically by name
      this.PHCLookup = PHCData.sort((a, b) =>
        (a.p.name || "").localeCompare(b.p.name || ""),
      );
      this.PHCList = [...this.PHCLookup];

      //  Extract unique States from Asha data and build State list
      const stateMap = new Map();
      PHCData.forEach((asha) => {
        if (asha.p.state_id > 0 && !stateMap.has(asha.p.state_id)) {
          let state = State.CreateNewInstance();
          state.p.id = asha.p.state_id;
          state.p.name_en = asha.p.state_name_en;
          // state.p.name_mr = asha.p.state_name_mr;
          stateMap.set(asha.p.state_id, state);
        }
      });
      if (Array.from(stateMap.values()).length > 0) {
        this.StateLookup = Array.from(stateMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log("   this.PHCData StateLookup serv:", this.StateLookup);
        this.StateList = [...this.StateLookup];
      }

      //  Extract unique Zones from Asha data and build Zone list
      const zoneMap = new Map();
      PHCData.forEach((asha) => {
        if (asha.p.zone_id && !zoneMap.has(asha.p.zone_id)) {
          let zone = Zone.CreateNewInstance();
          zone.p.id = asha.p.zone_id;
          zone.p.name = asha.p.zone_name;
          zone.p.state_id = asha.p.state_id;
          zoneMap.set(asha.p.zone_id, zone);
        }
      });
      if (Array.from(zoneMap.values()).length > 0) {
        this.ZoneLookup = Array.from(zoneMap.values()).sort((a, b) =>
          (a.p.Name || "").localeCompare(b.p.Name || ""),
        );
        console.log(" this.PHCData ZoneLookup  serv:", this.ZoneLookup);
        this.ZoneList = [...this.ZoneLookup];
      }

      //  Extract unique Districts from Asha data and build District list
      const districtMap = new Map();
      PHCData.forEach((asha) => {
        if (asha.p.district_id && !districtMap.has(asha.p.district_id)) {
          let district = District.CreateNewInstance();
          district.p.id = asha.p.district_id;
          district.p.name_en = asha.p.district_name_en;
          // district.p.name_mr = asha.p.district_name_mr;
          district.p.zone_id = asha.p.zone_id;
          district.p.state_id = asha.p.state_id;
          districtMap.set(asha.p.district_id, district);
        }
      });
      if (Array.from(districtMap.values()).length > 0) {
        this.DistrictLookup = Array.from(districtMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log("this.PHCData DistrictLookup serv :", this.DistrictLookup);
        this.DistrictList = [...this.DistrictLookup];
      }

      //  Extract unique Blocks from Asha data and build Block list
      const blockMap = new Map();
      PHCData.forEach((asha) => {
        if (asha.p.block_id && !blockMap.has(asha.p.block_id)) {
          let block = Block.CreateNewInstance();
          block.p.id = asha.p.block_id;
          block.p.name_en = asha.p.block_name_en;
          // block.p.name_mr = asha.p.block_name_mr;
          block.p.district_id = asha.p.district_id;
          block.p.zone_id = asha.p.zone_id;
          block.p.state_id = asha.p.state_id;
          blockMap.set(asha.p.block_id, block);
        }
      });
      if (Array.from(blockMap.values()).length > 0) {
        this.BlockLookup = Array.from(blockMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log(" this.PHCData BlockLookup :", this.BlockLookup);
        this.BlockList = [...this.BlockLookup];
      }

      // Generate BCMPostNameList from Block Ref List
      if (this.BlockList.length > 0) {
        let block_idList = this.BlockList.map((e) => e.p.id);
        let BCMPostNameList =
          await BcmPostMaster.FetchEntireListWithVacantByBlockList(
            block_idList,
            async (errMsg) =>
              await this.uiUtils.showErrorMessage("Error", errMsg),
          );
        const blockpostMap = new Map();
        if (BCMPostNameList.length > 0) {
          BCMPostNameList.forEach((bcmpostname) => {
            if (bcmpostname.p.id && !blockpostMap.has(bcmpostname.p.id)) {
            }
            let blockpost = BcmPostMaster.CreateNewInstance();
            blockpost.p.id = bcmpostname.p.id;
            blockpost.p.name = bcmpostname.p.full_name;;
            blockpost.p.block_id = bcmpostname.p.block_id;
            blockpost.p.district_id = bcmpostname.p.district_id;
            blockpost.p.zone_id = bcmpostname.p.zone_id;
            blockpost.p.state_id = bcmpostname.p.state_id;

            blockpostMap.set(blockpost.p.id, blockpost);
          });

          if (Array.from(blockpostMap.values()).length > 0) {
            this.BCMPostLookup = Array.from(blockpostMap.values()).sort(
              (a, b) => (a.p.Name || "").localeCompare(b.p.Name || ""),
            );
            console.log(" this.AFPostData BCMPostLookup :", this.BCMPostLookup);
            this.BCMPostList = [...this.BCMPostLookup];
          }
        }
      }

      // //  Extract unique Blocks from Asha data and build Block list
      // const blockpostMap = new Map();
      // PHCData.forEach((asha) => {
      //   if (asha.p.bcm_post_id && !blockpostMap.has(asha.p.bcm_post_id)) {
      //     let blockpost = BcmPostMaster.CreateNewInstance();
      //     blockpost.p.id = asha.p.bcm_post_id;
      //     blockpost.p.Name = asha.p.BCMPostName;
      //     blockpost.p.block_id = asha.p.block_id;
      //     blockpost.p.district_id = asha.p.district_id;
      //     blockpost.p.zone_id = asha.p.zone_id;
      //     blockpost.p.state_id = asha.p.state_id;
      //     blockpostMap.set(asha.p.bcm_post_id, blockpost);
      //   }
      // });
      // if (Array.from(blockpostMap.values()).length > 0) {
      //   this.BCMPostLookup = Array.from(blockpostMap.values()).sort((a, b) =>
      //     (a.p.Name || "").localeCompare(b.p.Name || "")
      //   );
      //   console.log(" this.PHCData BCMPostLookup :", this.BCMPostLookup);
      //   this.BCMPostList = [...this.BCMPostLookup];
      // }

      //  Extract unique PHCs from Asha data and build PHC list
      const phcMap = new Map();
      PHCData.forEach((asha) => {
        if (asha.p.id && !phcMap.has(asha.p.id)) {
          let phc = PHC.CreateNewInstance();
          phc.p.id = asha.p.id;
          phc.p.name = asha.p.name;
          phc.p.block_id = asha.p.block_id;
          phc.p.bcm_post_id = asha.p.bcm_post_id;
          // phc.p.bcm_post_name = asha.p.bcm_post_name;
          phc.p.district_id = asha.p.district_id;
          phc.p.zone_id = asha.p.zone_id;
          phc.p.state_id = asha.p.state_id;
          phcMap.set(asha.p.id, phc);
        }
      });
      if (Array.from(phcMap.values()).length > 0) {
        this.PHCLookup = Array.from(phcMap.values()).sort((a, b) =>
          (a.p.Name || "").localeCompare(b.p.Name || ""),
        );
        console.log(" this.PHCData PHCLookup serv:", this.PHCLookup);
        this.PHCList = [...this.PHCLookup];
      }

      //   Auto-select and disable dropdowns with only one option
      if (this.StateLookup.length === 1) {
        this.state_id = this.StateLookup[0].p.id;
        this.IsStateDisabled = true;
      } else {
        this.state_id = this.filterState$.value.state_id;
      }
      if (this.ZoneLookup.length === 1) {
        this.zone_id = this.ZoneLookup[0].p.id;
        this.IsZoneDisabled = true;
      } else {
        this.zone_id = this.filterState$.value.zone_id;
      }
      if (this.DistrictLookup.length === 1) {
        this.district_id = this.DistrictLookup[0].p.id;
        this.IsDistrictDisabled = true;
      } else {
        this.district_id = this.filterState$.value.district_id;
      }
      if (this.BlockLookup.length === 1) {
        this.block_id = this.BlockLookup[0].p.id;
        this.IsBlockDisabled = true;
      } else {
        this.block_id = this.filterState$.value.block_id;
      }

      // ** bcmpost **

      if (this.BCMPostLookup.length === 1) {
        this.bcm_post_id = this.BCMPostLookup[0].p.id;
        this.IsBCMPostDisabled = true;
      } else {
        this.bcm_post_id = this.filterState$.value.bcm_post_id;
      }

      // ** bcmpost End **

      if (this.PHCLookup.length === 1) {
        this.phc_id = this.PHCLookup[0].p.id;
        this.IsPHCDisabled = true;
      } else {
        this.phc_id = this.filterState$.value.phc_id;
      }

      // ✅ IMPORTANT: Apply filters to populate cascading dropdowns
      this.applyFilters();

      response.state_id = this.state_id;
      response.zone_id = this.zone_id;
      response.district_id = this.district_id;
      response.block_id = this.block_id;
      response.bcm_post_id = this.bcm_post_id; // ** bcmpost **
      response.phc_id = this.phc_id;

      return response;
    } catch (error) {
      await this.uiUtils.showErrorMessage(
        "Error",
        "Failed to load hierarchy data",
      );
      return response;
    } finally {
      //  Re-enable change notifications after 100ms (ensures all UI bindings complete)
      setTimeout(() => {
        this.isInitializing = false;
      }, 100);
    }
  }
  // ******** End Code of LoadFilterDataUPTO PHC Level  ********8

  // ✅ Load UpTo Asha Data from API
  async LoadFilterDataUPTOAshaLevel(
    UpTO: number,
    errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance()
      .GlobalUIErrorHandler,
  ): Promise<ResponseProps> {
    let response = new ResponseProps();
    console.log("response transaction :", response);

    //  Disable change notifications during data load to prevent cascading API calls
    this.isInitializing = true;

    try {
      // Fetch all Asha records with hierarchy data from API
      var ashaData =
        await AshaEmployeeRecord.FetchEntireListForTransactionFilter(
          async (errMsg) =>
            await this.uiUtils.showErrorMessage("Error", errMsg),
        );
      console.log("`ashaData` :", ashaData);

      if (ashaData.length === 0) {
        await this.uiUtils.showErrorMessage("Error", "No Asha Found");
        return response;
      }

      // Sort Asha Employee Record List alphabetically by name
      this.AshaEmployeeRecordLookup = ashaData.sort((a, b) =>
        (a.p.asha_full_name || "").localeCompare(b.p.asha_full_name || ""),
      );
      this.AshaEmployeeRecordList = [...this.AshaEmployeeRecordLookup];

      //  Extract unique States from Asha data and build State list
      const stateMap = new Map();
      ashaData.forEach((asha) => {
        if (asha.p.state_id > 0 && !stateMap.has(asha.p.state_id)) {
          let state = State.CreateNewInstance();
          state.p.id = asha.p.state_id;
          state.p.name_en = asha.p.state_name_en;
          state.p.name_mr = asha.p.state_name_mr;
          stateMap.set(asha.p.state_id, state);
        }
      });
      if (Array.from(stateMap.values()).length > 0) {
        this.StateLookup = Array.from(stateMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log("   this.StateLookup serv:", this.StateLookup);
        this.StateList = [...this.StateLookup];
      }

      //  Extract unique Zones from Asha data and build Zone list
      const zoneMap = new Map();
      ashaData.forEach((asha) => {
        if (asha.p.zone_id && !zoneMap.has(asha.p.zone_id)) {
          let zone = Zone.CreateNewInstance();
          zone.p.id = asha.p.zone_id;
          zone.p.name = asha.p.zone_name;
          zone.p.state_id = asha.p.state_id;
          zoneMap.set(asha.p.zone_id, zone);
        }
      });
      if (Array.from(zoneMap.values()).length > 0) {
        this.ZoneLookup = Array.from(zoneMap.values()).sort((a, b) =>
          (a.p.Name || "").localeCompare(b.p.Name || ""),
        );
        console.log(" this.ZoneLookup  serv:", this.ZoneLookup);
        this.ZoneList = [...this.ZoneLookup];
      }

      //  Extract unique Districts from Asha data and build District list
      const districtMap = new Map();
      ashaData.forEach((asha) => {
        if (asha.p.district_id && !districtMap.has(asha.p.district_id)) {
          let district = District.CreateNewInstance();
          district.p.id = asha.p.district_id;
          district.p.name_en = asha.p.district_name_en;
          district.p.name_mr = asha.p.district_name_mr;
          district.p.zone_id = asha.p.zone_id;
          district.p.state_id = asha.p.state_id;
          districtMap.set(asha.p.district_id, district);
        }
      });
      if (Array.from(districtMap.values()).length > 0) {
        this.DistrictLookup = Array.from(districtMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log("this.DistrictLookup serv :", this.DistrictLookup);
        this.DistrictList = [...this.DistrictLookup];
      }

      //  Extract unique Blocks from Asha data and build Block list
      const blockMap = new Map();
      ashaData.forEach((asha) => {
        if (asha.p.block_id && !blockMap.has(asha.p.block_id)) {
          let block = Block.CreateNewInstance();
          block.p.id = asha.p.block_id;
          block.p.name_en = asha.p.block_name_en;
          block.p.name_mr = asha.p.block_name_mr;
          block.p.district_id = asha.p.district_id;
          block.p.zone_id = asha.p.zone_id;
          block.p.state_id = asha.p.state_id;
          blockMap.set(asha.p.block_id, block);
        }
      });
      if (Array.from(blockMap.values()).length > 0) {
        this.BlockLookup = Array.from(blockMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log(" this.BlockLookup :", this.BlockLookup);
        this.BlockList = [...this.BlockLookup];
      }

      // Generate BCMPostNameList from Block Ref List
      if (this.BlockList.length > 0) {
        let block_idList = this.BlockList.map((e) => e.p.id);
        let BCMPostNameList =
          await BcmPostMaster.FetchEntireListWithVacantByBlockList(
            block_idList,
            async (errMsg) =>
              await this.uiUtils.showErrorMessage("Error", errMsg),
          );
        const blockpostMap = new Map();
        if (BCMPostNameList.length > 0) {
          BCMPostNameList.forEach((bcmpostname) => {
            if (bcmpostname.p.id && !blockpostMap.has(bcmpostname.p.id)) {
            }
            let blockpost = BcmPostMaster.CreateNewInstance();
            blockpost.p.id = bcmpostname.p.id;
            blockpost.p.name = bcmpostname.p.full_name;
            blockpost.p.block_id = bcmpostname.p.block_id;
            blockpost.p.district_id = bcmpostname.p.district_id;
            blockpost.p.zone_id = bcmpostname.p.zone_id;
            blockpost.p.state_id = bcmpostname.p.state_id;

            blockpostMap.set(blockpost.p.id, blockpost);
          });

          if (Array.from(blockpostMap.values()).length > 0) {
            this.BCMPostLookup = Array.from(blockpostMap.values()).sort(
              (a, b) => (a.p.Name || "").localeCompare(b.p.Name || ""),
            );
            console.log(" this.AFPostData BCMPostLookup :", this.BCMPostLookup);
            this.BCMPostList = [...this.BCMPostLookup];
          }
        }
      }

      // //  Extract unique Blocks from Asha data and build Block list
      // const blockpostMap = new Map();
      // ashaData.forEach((asha) => {
      //   if (asha.p.bcm_post_id && !blockpostMap.has(asha.p.bcm_post_id)) {
      //     let blockpost = BcmPostMaster.CreateNewInstance();
      //     blockpost.p.id = asha.p.bcm_post_id;
      //     blockpost.p.Name = asha.p.BCMPostName;
      //     blockpost.p.block_id = asha.p.block_id;
      //     blockpost.p.district_id = asha.p.district_id;
      //     blockpost.p.zone_id = asha.p.zone_id;
      //     blockpost.p.state_id = asha.p.state_id;
      //     blockpostMap.set(asha.p.bcm_post_id, blockpost);
      //   }
      // });
      // if (Array.from(blockpostMap.values()).length > 0) {
      //   this.BCMPostLookup = Array.from(blockpostMap.values()).sort((a, b) =>
      //     (a.p.Name || "").localeCompare(b.p.Name || "")
      //   );
      //   console.log(" this.BCMPostLookup :", this.BCMPostLookup);
      //   this.BCMPostList = [...this.BCMPostLookup];
      // }

      //  Extract unique PHCs from Asha data and build PHC list
      const phcMap = new Map();
      ashaData.forEach((asha) => {
        if (asha.p.phc_id && !phcMap.has(asha.p.phc_id)) {
          let phc = PHC.CreateNewInstance();
          phc.p.id = asha.p.phc_id;
          phc.p.name = asha.p.phc_name;
          phc.p.block_id = asha.p.block_id;
          phc.p.bcm_post_id = asha.p.bcm_post_id;
          // phc.p.bcm_post_name = asha.p.bcm_post_name;
          phc.p.district_id = asha.p.district_id;
          phc.p.zone_id = asha.p.zone_id;
          phc.p.state_id = asha.p.state_id;
          phcMap.set(asha.p.phc_id, phc);
        }
      });
      if (Array.from(phcMap.values()).length > 0) {
        this.PHCLookup = Array.from(phcMap.values()).sort((a, b) =>
          (a.p.Name || "").localeCompare(b.p.Name || ""),
        );
        console.log(" this.PHCLookup serv:", this.PHCLookup);
        this.PHCList = [...this.PHCLookup];
      }

      //  Extract unique BCM Posts from Asha data and build BCM Post List
      const afpostMap = new Map();
      ashaData.forEach((asha) => {
        if (
          asha.p.under_supervision &&
          !afpostMap.has(asha.p.under_supervision)
        ) {
          let afpost = AFPostMaster.CreateNewInstance();
          afpost.p.id = asha.p.under_supervision;
          afpost.p.name = asha.p.af_post_name;
          afpost.p.block_id = asha.p.block_id;
          afpost.p.bcm_post_id = asha.p.bcm_post_id;
          afpost.p.district_id = asha.p.district_id;
          afpost.p.zone_id = asha.p.zone_id;
          afpost.p.state_id = asha.p.state_id;
          afpost.p.phc_id = asha.p.phc_id;
          // afpost.p.af_post_id =  asha.p.under_supervision;
          afpostMap.set(asha.p.under_supervision, afpost);
        }
      });
      if (Array.from(afpostMap.values()).length > 0) {
        this.AFPostLookup = Array.from(afpostMap.values()).sort((a, b) =>
          (a.p.Name || "").localeCompare(b.p.Name || ""),
        );
        console.log("this.AFPostLookup serv:", this.AFPostLookup);
        this.AFPostList = [...this.AFPostLookup];
      }

      //  Extract unique SCs from Asha data and build SC list
      const scMap = new Map();
      ashaData.forEach((asha) => {
        if (asha.p.sc_id && !scMap.has(asha.p.sc_id)) {
          let sc = SC.CreateNewInstance();
          sc.p.id = asha.p.sc_id;
          sc.p.name = asha.p.sc_name;
          sc.p.phc_id = asha.p.phc_id;
          sc.p.block_id = asha.p.block_id;
          sc.p.district_id = asha.p.district_id;
          sc.p.zone_id = asha.p.zone_id;
          sc.p.state_id = asha.p.state_id;
          scMap.set(asha.p.sc_id, sc);
        }
      });
      if (Array.from(scMap.values()).length > 0) {
        this.SCLookup = Array.from(scMap.values()).sort((a, b) =>
          (a.p.Name || "").localeCompare(b.p.Name || ""),
        );
        this.SCList = [...this.SCLookup];
      }

      //  Extract unique Villages from Asha data and build Village list
      const villageMap = new Map();
      ashaData.forEach((asha) => {
        if (asha.p.village_id && !villageMap.has(asha.p.village_id)) {
          let village = Village.CreateNewInstance();
          village.p.id = asha.p.village_id;
          village.p.name_en = asha.p.village_name_en;
          village.p.name_mr = asha.p.village_name_mr;
          village.p.phc_id = asha.p.phc_id;
          village.p.block_id = asha.p.block_id;
          village.p.district_id = asha.p.district_id;
          village.p.zone_id = asha.p.zone_id;
          village.p.state_id = asha.p.state_id;
          village.p.sc_id = asha.p.sc_id;
          villageMap.set(asha.p.village_id, village);
        }
      });
      if (Array.from(villageMap.values()).length > 0) {
        this.VillageLookup = Array.from(villageMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        this.VillageList = [...this.VillageLookup];
      }

      //   Auto-select and disable dropdowns with only one option
      if (this.StateLookup.length === 1) {
        this.state_id = this.StateLookup[0].p.id;
        this.IsStateDisabled = true;
      } else {
        this.state_id = this.filterState$.value.state_id;
      }
      if (this.ZoneLookup.length === 1) {
        this.zone_id = this.ZoneLookup[0].p.id;
        this.IsZoneDisabled = true;
      } else {
        this.zone_id = this.filterState$.value.zone_id;
      }
      if (this.DistrictLookup.length === 1) {
        this.district_id = this.DistrictLookup[0].p.id;
        this.IsDistrictDisabled = true;
      } else {
        this.district_id = this.filterState$.value.district_id;
      }
      if (this.BlockLookup.length === 1) {
        this.block_id = this.BlockLookup[0].p.id;
        this.IsBlockDisabled = true;
      } else {
        this.block_id = this.filterState$.value.block_id;
      }

      // ** bcmpost **

      if (this.BCMPostLookup.length === 1) {
        this.bcm_post_id = this.BCMPostLookup[0].p.id;
        this.IsBCMPostDisabled = true;
      } else {
        this.bcm_post_id = this.filterState$.value.bcm_post_id;
      }

      // ** bcmpost End **

      if (this.PHCLookup.length === 1) {
        this.phc_id = this.PHCLookup[0].p.id;
        this.IsPHCDisabled = true;
      } else {
        this.phc_id = this.filterState$.value.phc_id;
      }

      if (this.AFPostLookup.length === 1) {
        this.af_post_id = this.AFPostLookup[0].p.id;
        this.IsAFPostDisabled = true;
      } else {
        this.af_post_id = this.filterState$.value.af_post_id;
      }

      if (this.SCLookup.length === 1) {
        this.sc_id = this.SCLookup[0].p.id;
        this.IsSCDisabled = true;
      } else {
        this.sc_id = this.filterState$.value.sc_id;
      }
      if (this.VillageList.length === 1) {
        this.village_id = this.VillageList[0].p.id;
        this.IsVillageDisabled = true;
      } else {
        this.village_id = this.filterState$.value.village_id;
      }
      if (ashaData.length === 1) {
        this.asha_employee_record_id = ashaData[0].p.id;
        this.IsAshaEmployeeRecordDisabled = true;
      } else {
        this.asha_employee_record_id =
          this.filterState$.value.asha_employee_record_id;
      }

      // ✅ IMPORTANT: Apply filters to populate cascading dropdowns
      this.applyFilters();

      response.state_id = this.state_id;
      response.zone_id = this.zone_id;
      response.district_id = this.district_id;
      response.block_id = this.block_id;
      response.bcm_post_id = this.bcm_post_id; // ** bcmpost **
      response.phc_id = this.phc_id;
      response.af_post_id = this.af_post_id;
      response.sc_id = this.sc_id;
      response.village_id = this.village_id;
      response.asha_employee_record_id = this.asha_employee_record_id;

      return response;
    } catch (error) {
      await this.uiUtils.showErrorMessage(
        "Error",
        "Failed to load hierarchy data",
      );
      return response;
    } finally {
      //  Re-enable change notifications after 100ms (ensures all UI bindings complete)
      setTimeout(() => {
        this.isInitializing = false;
      }, 100);
    }
  }

  // ✅ Load Up To AF Data from API
  async LoadFilterDataUPTOAFLevel(
    UpTO: number,
    errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance()
      .GlobalUIErrorHandler,
  ): Promise<ResponseProps> {
    let response = new ResponseProps();

    //  Disable change notifications during data load to prevent cascading API calls
    this.isInitializing = true;

    try {
      // Fetch all af records with hierarchy data from API
      var AFEmployeeData =
        await BFEmployeeRecord.FetchEntireListForReportFilter(
          async (errMsg) =>
            await this.uiUtils.showErrorMessage("Error", errMsg),
        );
      console.log("`AFEmployeeData` :", AFEmployeeData);

      if (AFEmployeeData.length === 0) {
        await this.uiUtils.showErrorMessage("Error", "No AF Found");
        return response;
      }

      // Sort af Employee Record List alphabetically by name
      this.AFEmployeeRecordLookup = AFEmployeeData.sort((a, b) =>
        (a.p.full_name || "").localeCompare(b.p.full_name || ""),
      );
      this.AFEmployeeRecordList = [...this.AFEmployeeRecordLookup];

      //  Extract unique States from af data and build State list
      const stateMap = new Map();
      AFEmployeeData.forEach((af) => {
        if (af.p.state_id > 0 && !stateMap.has(af.p.state_id)) {
          let state = State.CreateNewInstance();
          state.p.id = af.p.state_id;
          state.p.name_en = af.p.state_name_en;
          // state.p.name_mr = af.p.state_name_mr;
          stateMap.set(af.p.state_id, state);
        }
      });
      if (Array.from(stateMap.values()).length > 0) {
        this.StateLookup = Array.from(stateMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log(
          "   this.AFEmployeeData StateLookup serv:",
          this.StateLookup,
        );
        this.StateList = [...this.StateLookup];
      }

      //  Extract unique Zones from af data and build Zone list
      const zoneMap = new Map();
      AFEmployeeData.forEach((af) => {
        if (af.p.zone_id && !zoneMap.has(af.p.zone_id)) {
          let zone = Zone.CreateNewInstance();
          zone.p.id = af.p.zone_id;
          zone.p.name = af.p.zone_name;
          zone.p.state_id = af.p.state_id;
          zoneMap.set(af.p.zone_id, zone);
        }
      });
      if (Array.from(zoneMap.values()).length > 0) {
        this.ZoneLookup = Array.from(zoneMap.values()).sort((a, b) =>
          (a.p.Name || "").localeCompare(b.p.Name || ""),
        );
        console.log(" this.AFEmployeeData ZoneLookup  serv:", this.ZoneLookup);
        this.ZoneList = [...this.ZoneLookup];
      }

      //  Extract unique Districts from af data and build District list
      const districtMap = new Map();
      AFEmployeeData.forEach((af) => {
        if (af.p.district_id && !districtMap.has(af.p.district_id)) {
          let district = District.CreateNewInstance();
          district.p.id = af.p.district_id;
          district.p.name_en = af.p.district_name_en;
          // district.p.name_mr = af.p.district_name_mr;
          district.p.zone_id = af.p.zone_id;
          district.p.state_id = af.p.state_id;
          districtMap.set(af.p.district_id, district);
        }
      });
      if (Array.from(districtMap.values()).length > 0) {
        this.DistrictLookup = Array.from(districtMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log(
          "this.AFEmployeeData DistrictLookup serv :",
          this.DistrictLookup,
        );
        this.DistrictList = [...this.DistrictLookup];
      }

      //  Extract unique Blocks from af data and build Block list
      const blockMap = new Map();
      AFEmployeeData.forEach((af) => {
        if (af.p.block_id && !blockMap.has(af.p.block_id)) {
          let block = Block.CreateNewInstance();
          block.p.id = af.p.block_id;
          block.p.name_en = af.p.block_name_en;
          // block.p.name_mr = af.p.block_name_mr;
          block.p.district_id = af.p.district_id;
          block.p.zone_id = af.p.zone_id;
          block.p.state_id = af.p.state_id;
          blockMap.set(af.p.block_id, block);
        }
      });
      if (Array.from(blockMap.values()).length > 0) {
        this.BlockLookup = Array.from(blockMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log(" this.AFEmployeeData BlockLookup :", this.BlockLookup);
        this.BlockList = [...this.BlockLookup];
      }

      // Generate BCMPostNameList from Block Ref List
      if (this.BlockList.length > 0) {
        let block_idList = this.BlockList.map((e) => e.p.id);
        let BCMPostNameList =
          await BcmPostMaster.FetchEntireListWithVacantByBlockList(
            block_idList,
            async (errMsg) =>
              await this.uiUtils.showErrorMessage("Error", errMsg),
          );
        const blockpostMap = new Map();
        if (BCMPostNameList.length > 0) {
          BCMPostNameList.forEach((bcmpostname) => {
            if (bcmpostname.p.id && !blockpostMap.has(bcmpostname.p.id)) {
            }
            let blockpost = BcmPostMaster.CreateNewInstance();
            blockpost.p.id = bcmpostname.p.id;
            blockpost.p.name = bcmpostname.p.full_name;
            blockpost.p.block_id = bcmpostname.p.block_id;
            blockpost.p.district_id = bcmpostname.p.district_id;
            blockpost.p.zone_id = bcmpostname.p.zone_id;
            blockpost.p.state_id = bcmpostname.p.state_id;

            blockpostMap.set(blockpost.p.id, blockpost);
          });

          if (Array.from(blockpostMap.values()).length > 0) {
            this.BCMPostLookup = Array.from(blockpostMap.values()).sort(
              (a, b) => (a.p.Name || "").localeCompare(b.p.Name || ""),
            );
            console.log(" this.AFPostData BCMPostLookup :", this.BCMPostLookup);
            this.BCMPostList = [...this.BCMPostLookup];
          }
        }
      }

      // //  Extract unique Blocks from af data and build Block list
      // const blockpostMap = new Map();
      // AFEmployeeData.forEach((af) => {
      //   if (af.p.bcm_post_id && !blockpostMap.has(af.p.bcm_post_id)) {
      //     let blockpost = BcmPostMaster.CreateNewInstance();
      //     blockpost.p.id = af.p.bcm_post_id;
      //     blockpost.p.Name = af.p.BCMPostName;
      //     blockpost.p.block_id = af.p.block_id;
      //     blockpost.p.district_id = af.p.district_id;
      //     blockpost.p.zone_id = af.p.zone_id;
      //     blockpost.p.state_id = af.p.state_id;
      //     blockpostMap.set(af.p.bcm_post_id, blockpost);
      //   }
      // });
      // if (Array.from(blockpostMap.values()).length > 0) {
      //   this.BCMPostLookup = Array.from(blockpostMap.values()).sort((a, b) =>
      //     (a.p.Name || "").localeCompare(b.p.Name || "")
      //   );
      //   console.log(" this.AFEmployeeData BCMPostLookup :", this.BCMPostLookup);
      //   this.BCMPostList = [...this.BCMPostLookup];
      // }

      //  Extract unique PHCs from af data and build PHC list
      const phcMap = new Map();
      AFEmployeeData.forEach((af) => {
        if (af.p.phc_id && !phcMap.has(af.p.phc_id)) {
          let phc = PHC.CreateNewInstance();
          phc.p.id = af.p.phc_id;
          phc.p.name = af.p.phc_name;
          phc.p.block_id = af.p.block_id;
          phc.p.bcm_post_id = af.p.bcm_post_id;
          // phc.p.bcm_post_name = af.p.bcm_post_name;
          phc.p.district_id = af.p.district_id;
          phc.p.zone_id = af.p.zone_id;
          phc.p.state_id = af.p.state_id;
          phcMap.set(af.p.phc_id, phc);
        }
      });
      if (Array.from(phcMap.values()).length > 0) {
        this.PHCLookup = Array.from(phcMap.values()).sort((a, b) =>
          (a.p.Name || "").localeCompare(b.p.Name || ""),
        );
        console.log(" this.AFEmployeeData PHCLookup serv:", this.PHCLookup);
        this.PHCList = [...this.PHCLookup];
      }

      //  Extract unique BCM Posts from af data and build BCM Post List
      const afemployeeMap = new Map();
      AFEmployeeData.forEach((af) => {
        if (af.p.id && !afemployeeMap.has(af.p.id)) {
          let afemployee = BFEmployeeRecord.CreateNewInstance();
          afemployee.p.id = af.p.id;
          afemployee.p.full_name = af.p.full_name;
          afemployee.p.block_id = af.p.block_id;
          afemployee.p.bcm_post_id = af.p.bcm_post_id;
          afemployee.p.district_id = af.p.district_id;
          afemployee.p.zone_id = af.p.zone_id;
          afemployee.p.state_id = af.p.state_id;
          afemployee.p.phc_id = af.p.phc_id;
          afemployee.p.af_post_id = af.p.af_post_id;
          afemployeeMap.set(af.p.id, afemployee);
        }
      });
      if (Array.from(afemployeeMap.values()).length > 0) {
        this.AFEmployeeLookup = Array.from(afemployeeMap.values()).sort(
          (a, b) => (a.p.FullName || "").localeCompare(b.p.FullName || ""),
        );
        this.AFEmployeeRecordList = [...this.AFEmployeeLookup];
      }

      //   Auto-select and disable dropdowns with only one option
      if (this.StateLookup.length === 1) {
        this.state_id = this.StateLookup[0].p.id;
        this.IsStateDisabled = true;
      } else {
        this.state_id = this.filterState$.value.state_id;
      }
      if (this.ZoneLookup.length === 1) {
        this.zone_id = this.ZoneLookup[0].p.id;
        this.IsZoneDisabled = true;
      } else {
        this.zone_id = this.filterState$.value.zone_id;
      }
      if (this.DistrictLookup.length === 1) {
        this.district_id = this.DistrictLookup[0].p.id;
        this.IsDistrictDisabled = true;
      } else {
        this.district_id = this.filterState$.value.district_id;
      }
      if (this.BlockLookup.length === 1) {
        this.block_id = this.BlockLookup[0].p.id;
        this.IsBlockDisabled = true;
      } else {
        this.block_id = this.filterState$.value.block_id;
      }

      // ** bcmpost **

      if (this.BCMPostLookup.length === 1) {
        this.bcm_post_id = this.BCMPostLookup[0].p.id;
        this.IsBCMPostDisabled = true;
      } else {
        this.bcm_post_id = this.filterState$.value.bcm_post_id;
      }

      // ** bcmpost End **

      if (this.PHCLookup.length === 1) {
        this.phc_id = this.PHCLookup[0].p.id;
        this.IsPHCDisabled = true;
      } else {
        this.phc_id = this.filterState$.value.phc_id;
      }

      if (this.AFEmployeeLookup.length === 1) {
        this.af_employee_record_id = this.AFEmployeeLookup[0].p.id;
        this.IsAFEmployeeRecordDisabled = true;
      } else {
        this.af_employee_record_id = this.filterState$.value.af_employee_record_id;
      }

      // ✅ IMPORTANT: Apply filters to populate cascading dropdowns
      this.applyFilters();

      response.state_id = this.state_id;
      response.zone_id = this.zone_id;
      response.district_id = this.district_id;
      response.block_id = this.block_id;
      response.bcm_post_id = this.bcm_post_id; // ** bcmpost **
      response.phc_id = this.phc_id;
      response.af_employee_record_id = this.af_employee_record_id;

      return response;
    } catch (error) {
      await this.uiUtils.showErrorMessage(
        "Error",
        "Failed to load hierarchy data",
      );
      return response;
    } finally {
      //  Re-enable change notifications after 100ms (ensures all UI bindings complete)
      setTimeout(() => {
        this.isInitializing = false;
      }, 100);
    }
  }
  // ******** End Code of LoadFilterDataUPTO AF Level  ********8

  // ✅ Load Up To AF Data from API
  async LoadFilterDataUPTOAFPostLevel(
    UpTO: number,
    errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance()
      .GlobalUIErrorHandler,
  ): Promise<ResponseProps> {
    let response = new ResponseProps();

    //  Disable change notifications during data load to prevent cascading API calls
    this.isInitializing = true;

    try {
      // Fetch all af records with hierarchy data from API
      var AFPostData = await AFPostMaster.FetchEntireListForReportFilter(
        async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
      );

      if (AFPostData.length === 0) {
        await this.uiUtils.showErrorMessage("Error", "No AF post Found");
        return response;
      }

      // Sort af Employee Record List alphabetically by name
      this.AFPostLookup = AFPostData.sort((a, b) =>
        (a.p.name || "").localeCompare(b.p.name || ""),
      );
      this.AFPostList = [...this.AFPostLookup];

      //  Extract unique States from af data and build State list
      const stateMap = new Map();
      AFPostData.forEach((af) => {
        if (af.p.state_id > 0 && !stateMap.has(af.p.state_id)) {
          let state = State.CreateNewInstance();
          state.p.id = af.p.state_id;
          state.p.name_en = af.p.state_name_en;
          // state.p.name_mr = af.p.state_name_mr;
          stateMap.set(af.p.state_id, state);
        }
      });
      if (Array.from(stateMap.values()).length > 0) {
        this.StateLookup = Array.from(stateMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log("   this.AFPostData StateLookup serv:", this.StateLookup);
        this.StateList = [...this.StateLookup];
      }

      //  Extract unique Zones from af data and build Zone list
      const zoneMap = new Map();
      AFPostData.forEach((af) => {
        if (af.p.zone_id && !zoneMap.has(af.p.zone_id)) {
          let zone = Zone.CreateNewInstance();
          zone.p.id = af.p.zone_id;
          zone.p.name = af.p.zone_name;
          zone.p.state_id = af.p.state_id;
          zoneMap.set(af.p.zone_id, zone);
        }
      });
      if (Array.from(zoneMap.values()).length > 0) {
        this.ZoneLookup = Array.from(zoneMap.values()).sort((a, b) =>
          (a.p.Name || "").localeCompare(b.p.Name || ""),
        );
        console.log(" this.AFPostData ZoneLookup  serv:", this.ZoneLookup);
        this.ZoneList = [...this.ZoneLookup];
      }

      //  Extract unique Districts from af data and build District list
      const districtMap = new Map();
      AFPostData.forEach((af) => {
        if (af.p.district_id && !districtMap.has(af.p.district_id)) {
          let district = District.CreateNewInstance();
          district.p.id = af.p.district_id;
          district.p.name_en = af.p.district_name_en;
          // district.p.name_mr = af.p.district_name_mr;
          district.p.zone_id = af.p.zone_id;
          district.p.state_id = af.p.state_id;
          districtMap.set(af.p.district_id, district);
        }
      });
      if (Array.from(districtMap.values()).length > 0) {
        this.DistrictLookup = Array.from(districtMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log(
          "this.AFPostData DistrictLookup serv :",
          this.DistrictLookup,
        );
        this.DistrictList = [...this.DistrictLookup];
      }

      //  Extract unique Blocks from af data and build Block list
      const blockMap = new Map();
      AFPostData.forEach((af) => {
        if (af.p.block_id && !blockMap.has(af.p.block_id)) {
          let block = Block.CreateNewInstance();
          block.p.id = af.p.block_id;
          block.p.name_en = af.p.block_name_en;
          // block.p.name_mr = af.p.block_name_mr;
          block.p.district_id = af.p.district_id;
          block.p.zone_id = af.p.zone_id;
          block.p.state_id = af.p.state_id;
          blockMap.set(af.p.block_id, block);
        }
      });
      if (Array.from(blockMap.values()).length > 0) {
        this.BlockLookup = Array.from(blockMap.values()).sort((a, b) =>
          (a.p.name_en || "").localeCompare(b.p.name_en || ""),
        );
        console.log(" this.AFPostData BlockLookup :", this.BlockLookup);
        this.BlockList = [...this.BlockLookup];
      }

      // Generate BCMPostNameList from Block Ref List
      if (this.BlockList.length > 0) {
        let block_idList = this.BlockList.map((e) => e.p.id);
        let BCMPostNameList =
          await BcmPostMaster.FetchEntireListWithVacantByBlockList(
            block_idList,
            async (errMsg) =>
              await this.uiUtils.showErrorMessage("Error", errMsg),
          );
        const blockpostMap = new Map();
        if (BCMPostNameList.length > 0) {
          BCMPostNameList.forEach((bcmpostname) => {
            if (bcmpostname.p.id && !blockpostMap.has(bcmpostname.p.id)) {
            }
            let blockpost = BcmPostMaster.CreateNewInstance();
            blockpost.p.id = bcmpostname.p.id;
            blockpost.p.name = bcmpostname.p.full_name;
            blockpost.p.block_id = bcmpostname.p.block_id;
            blockpost.p.district_id = bcmpostname.p.district_id;
            blockpost.p.zone_id = bcmpostname.p.zone_id;
            blockpost.p.state_id = bcmpostname.p.state_id;

            blockpostMap.set(blockpost.p.id, blockpost);
          });

          if (Array.from(blockpostMap.values()).length > 0) {
            this.BCMPostLookup = Array.from(blockpostMap.values()).sort(
              (a, b) => (a.p.Name || "").localeCompare(b.p.Name || ""),
            );
            console.log(" this.AFPostData BCMPostLookup :", this.BCMPostLookup);
            this.BCMPostList = [...this.BCMPostLookup];
          }
        }
      }

      // //  Extract unique Blocks from af data and build Block list
      // const blockpostMap = new Map();
      // AFPostData.forEach((af) => {
      //   if (af.p.UnderSupervision && !blockpostMap.has(af.p.UnderSupervision)) {
      //     let blockpost = BcmPostMaster.CreateNewInstance();
      //    blockpost.p.id = af.p.UnderSupervision;
      //    blockpost.p.Name = af.p.BCMPostName;
      //    blockpost.p.block_id = af.p.block_id;
      //    blockpost.p.district_id = af.p.district_id;
      //    blockpost.p.zone_id = af.p.zone_id;
      //    blockpost.p.state_id = af.p.state_id;
      //     blockpostMap.set(af.p.UnderSupervision, blockpost);
      //   }
      // });
      // if (Array.from(blockpostMap.values()).length > 0) {
      //   this.BCMPostLookup = Array.from(blockpostMap.values()).sort((a, b) =>
      //     (a.p.Name || "").localeCompare(b.p.Name || "")
      //   );
      //   console.log(" this.AFPostData BCMPostLookup :", this.BCMPostLookup);
      //   this.BCMPostList = [...this.BCMPostLookup];
      // }
      // console.log('this.BCMPostList after :', this.BCMPostList);

      //  Extract unique PHCs from af data and build PHC list
      const phcMap = new Map();
      AFPostData.forEach((af) => {
        if (af.p.phc_id && !phcMap.has(af.p.phc_id)) {
          let phc = PHC.CreateNewInstance();
          phc.p.id = af.p.phc_id;
          phc.p.name = af.p.phc_name;
          phc.p.block_id = af.p.block_id;
          phc.p.bcm_post_id = af.p.under_supervision;
          // phc.p.BCMPostName = af.p.BCMPostName;
          phc.p.district_id = af.p.district_id;
          phc.p.zone_id = af.p.zone_id;
          phc.p.state_id = af.p.state_id;
          phcMap.set(af.p.phc_id, phc);
        }
      });
      if (Array.from(phcMap.values()).length > 0) {
        this.PHCLookup = Array.from(phcMap.values()).sort((a, b) =>
          (a.p.Name || "").localeCompare(b.p.Name || ""),
        );
        console.log(" this.AFPostData PHCLookup serv:", this.PHCLookup);
        this.PHCList = [...this.PHCLookup];
      }

      // //  Extract unique BCM Posts from af data and build BCM Post List
      // const afemployeeMap = new Map();
      // AFPostData.forEach((af) => {
      //   if (
      //     af.p.id &&
      //     !afemployeeMap.has(af.p.id)
      //   ) {
      //     let afemployee = BFEmployeeRecord.CreateNewInstance();
      //     afemployee.p.id = af.p.id;
      //     afemployee.p.FullName = af.p.FullName;
      //     afemployee.p.block_id = af.p.block_id;
      //     afemployee.p.bcm_post_id = af.p.bcm_post_id;
      //     afemployee.p.district_id = af.p.district_id;
      //     afemployee.p.zone_id = af.p.zone_id;
      //     afemployee.p.state_id = af.p.state_id;
      //     afemployee.p.phc_id = af.p.phc_id;
      //     // afpost.p.af_post_id = af.p.id;
      //     afemployeeMap.set(af.p.id, afemployee);
      //   }
      // });
      // if (Array.from(afemployeeMap.values()).length > 0) {
      //   this.AFEmployeeLookup = Array.from(afemployeeMap.values()).sort((a, b) =>
      //     (a.p.FullName || "").localeCompare(b.p.FullName || "")
      //   );
      //   console.log("this.AFEmployeeData AFEmployeeLookup serv:", this.AFEmployeeLookup);
      //   this.AFEmployeeRecordList = [...this.AFEmployeeLookup];
      // }

      //   Auto-select and disable dropdowns with only one option
      if (this.StateLookup.length === 1) {
        this.state_id = this.StateLookup[0].p.id;
        this.IsStateDisabled = true;
      } else {
        this.state_id = this.filterState$.value.state_id;
      }
      if (this.ZoneLookup.length === 1) {
        this.zone_id = this.ZoneLookup[0].p.id;
        this.IsZoneDisabled = true;
      } else {
        this.zone_id = this.filterState$.value.zone_id;
      }
      if (this.DistrictLookup.length === 1) {
        this.district_id = this.DistrictLookup[0].p.id;
        this.IsDistrictDisabled = true;
      } else {
        this.district_id = this.filterState$.value.district_id;
      }
      if (this.BlockLookup.length === 1) {
        this.block_id = this.BlockLookup[0].p.id;
        this.IsBlockDisabled = true;
      } else {
        this.block_id = this.filterState$.value.block_id;
      }

      // ** bcmpost **

      if (this.BCMPostLookup.length === 1) {
        this.bcm_post_id = this.BCMPostLookup[0].p.id;
        this.IsBCMPostDisabled = true;
      } else {
        this.bcm_post_id = this.filterState$.value.bcm_post_id;
      }

      // ** bcmpost End **

      if (this.PHCLookup.length === 1) {
        this.phc_id = this.PHCLookup[0].p.id;
        this.IsPHCDisabled = true;
      } else {
        this.phc_id = this.filterState$.value.phc_id;
      }

      if (this.AFEmployeeLookup.length === 1) {
        this.af_employee_record_id = this.AFEmployeeLookup[0].p.id;
        this.IsAFEmployeeRecordDisabled = true;
      } else {
        this.af_employee_record_id = this.filterState$.value.af_employee_record_id;
      }

       if (this.AFPostLookup.length === 1) {
        this.af_post_id = this.AFPostLookup[0].p.id;
        this.IsAFEmployeeRecordDisabled = true;
      } else {
        this.af_post_id = this.filterState$.value.af_post_id;
      }

      // ✅ IMPORTANT: Apply filters to populate cascading dropdowns
      this.applyFilters();

      response.state_id = this.state_id;
      response.zone_id = this.zone_id;
      response.district_id = this.district_id;
      response.block_id = this.block_id;
      response.bcm_post_id = this.bcm_post_id; // ** bcmpost **
      response.phc_id = this.phc_id;
      response.af_employee_record_id = this.af_employee_record_id;

      return response;
    } catch (error) {
      await this.uiUtils.showErrorMessage(
        "Error",
        "Failed to load hierarchy data",
      );
      return response;
    } finally {
      //  Re-enable change notifications after 100ms (ensures all UI bindings complete)
      setTimeout(() => {
        this.isInitializing = false;
      }, 100);
    }
  }
  // ******** End Code of LoadFilterDataUPTO AF Level  ********8

  // ✅ Apply saved filter state without triggering notifications
  applySavedFilterState(filters: FilterState) {
    this.isInitializing = true;

    this.state_id = filters.state_id || 0;
    this.zone_id = filters.zone_id || 0;
    this.district_id = filters.district_id || 0;
    this.block_id = filters.block_id || 0;
    this.bcm_post_id = filters.bcm_post_id || 0; // ** bcmpost **
    this.phc_id = filters.phc_id || 0;
    this.af_post_id = filters.af_post_id || 0;
    this.af_employee_record_id = filters.af_employee_record_id || 0;
    this.sc_id = filters.sc_id || 0;
    this.village_id = filters.village_id || 0;
    this.asha_employee_record_id = filters.asha_employee_record_id || 0;

    this.applyFilters();

    setTimeout(() => {
      this.isInitializing = false;
    }, 100);
  }

  public setFilterState = () => {
    const currentState = this.filterState$.value;
    this.financial_year_id = currentState.financial_year_id;
    this.month = currentState.month;
    this.state_id = currentState.state_id;
    this.zone_id = currentState.zone_id;
    this.district_id = currentState.district_id;
    this.block_id = currentState.block_id;
    this.phc_id = currentState.phc_id;
    this.af_post_id = currentState.af_post_id;
    this.sc_id = currentState.sc_id;
    this.village_id = currentState.village_id;
    this.bcm_post_id = currentState.bcm_post_id;
    this.asha_employee_record_id = currentState.asha_employee_record_id;
    this.af_employee_record_id = currentState.af_employee_record_id;
  };

  //  Filter and populate dependent dropdown lists based on parent selections
  private applyFilters() {
    /* ZONE (depends on State) */
    if (this.state_id > 0) {
      this.ZoneList = this.ZoneLookup.filter(
        (v) => v.p.state_id === this.state_id,
      ).sort((a, b) => (a.p.name || "").localeCompare(b.p.name || ""));

       if (this.ZoneList.length == 1) {
        this.zone_id = this.ZoneList[0].p.id;
        this.IsStateDisabled = true;
      } else {
        this.IsStateDisabled = false;
      }
    } else {
      this.ZoneList = [];
    }

    /* DISTRICT (depends on Zone) */

    if (this.zone_id > 0) {
      this.DistrictList = this.DistrictLookup.filter(
        (v) => v.p.zone_id === this.zone_id,
      ).sort((a, b) => (a.p.name_en || "").localeCompare(b.p.name_en || ""));

       if (this.DistrictList.length == 1) {
        this.district_id = this.DistrictList[0].p.id;
        this.IsDistrictDisabled = true;
      } else {
        this.IsDistrictDisabled = false;
      }
    } else {
      this.DistrictList = [];
    }
    /* BLOCK (depends on District) */
    if (this.district_id > 0) {
      this.BlockList = this.BlockLookup.filter(
        (v) => v.p.district_id === this.district_id,
      ).sort((a, b) => (a.p.name_en || "").localeCompare(b.p.name_en || ""));

       if (this.BlockList.length == 1) {
        this.block_id = this.BlockList[0].p.id;
        this.IsBlockDisabled = true;
      } else {
        this.IsBlockDisabled = false;
      }
    } else {
      this.BlockList = [];
    }

    /* BCM Post (depends on Block) */
    if (this.block_id > 0) {
      this.BCMPostList = this.BCMPostLookup.filter(
        (v) => v.p.block_id === this.block_id,
      ).sort((a, b) => (a.p.name || "").localeCompare(b.p.name || ""));

      if (this.BCMPostList.length == 1) {
        this.bcm_post_id = this.BCMPostList[0].p.id;
        this.IsBCMPostDisabled = true;
      } else {
        this.IsBCMPostDisabled = false;
      }
    } else {
      this.BCMPostList = [];
    }

    /* PHC (depends on BlockPost) */
    if (this.bcm_post_id > 0) {
      this.PHCList = this.PHCLookup.filter(
        (v) => v.p.bcm_post_id === this.bcm_post_id,
      ).sort((a, b) => (a.p.name || "").localeCompare(b.p.name || ""));

      if (this.PHCList.length == 1) {
        this.phc_id = this.PHCList[0].p.id;
        this.IsPHCDisabled = true;
      } else {
        this.IsPHCDisabled = false;
      }
    } else {
      this.PHCList = [];
    }

    /* AF Employee list  (depends on PHC) */
    if (this.phc_id > 0) {
      this.AFEmployeeRecordList = this.AFEmployeeLookup.filter(
        (v) => v.p.phc_id === this.phc_id,
        // (v) => v.p.phc_id === this.phc_id && v.p.bcm_post_id === this.bcm_post_id
      ).sort((a, b) => (a.p.full_name || "").localeCompare(b.p.full_name || ""));

       if (this.AFEmployeeRecordList.length == 1) {
        this.af_employee_record_id = this.AFEmployeeRecordList[0].p.id;
        this.IsAFEmployeeRecordDisabled = true;
      } else {
        this.IsAFEmployeeRecordDisabled = false;
      }
    } else {
      this.AFEmployeeRecordList = [];
    }

    /* AF POST (depends on PHC) */
    if (this.phc_id > 0) {
      this.AFPostList = this.AFPostLookup.filter(
        (v) => v.p.phc_id === this.phc_id,
        // (v) => v.p.phc_id === this.phc_id && v.p.bcm_post_id === this.bcm_post_id
      ).sort((a, b) => (a.p.name || "").localeCompare(b.p.name || ""));

       if (this.AFPostList.length == 1) {
        this.af_post_id = this.AFPostList[0].p.id;
        this.IsAFPostDisabled = true;
      } else {
        this.IsAFPostDisabled = false;
      }
    } else {
      this.AFPostList = [];
    }

    /* SC (depends on PHC) */
    if (this.phc_id > 0) {
      this.SCList = this.SCLookup.filter(
        (v) => v.p.phc_id === this.phc_id,
      ).sort((a, b) => (a.p.name || "").localeCompare(b.p.name || ""));

       if (this.SCList.length == 1) {
        this.sc_id = this.SCList[0].p.id;
        this.IsSCDisabled = true;
      } else {
        this.IsSCDisabled = false;
      }
    } else {
      this.SCList = [];
    }

    /* VILLAGE (depends on SC) */
    if (this.sc_id > 0) {
      this.VillageList = this.VillageLookup.filter(
        (v) => v.p.sc_id === this.sc_id,
      ).sort((a, b) => (a.p.name_en || "").localeCompare(b.p.name_en || ""));

       if (this.VillageList.length == 1) {
        this.village_id = this.VillageList[0].p.id;
        this.IsVillageDisabled = true;
      } else {
        this.IsVillageDisabled = false;
      }
    } else {
      this.VillageList = [];
    }

    /* ASHA (Village OR AF) */
    if (this.af_post_id > 0) {
      this.AshaEmployeeRecordList = this.AshaEmployeeRecordLookup.filter(
        (v) => v.p.under_supervision === this.af_post_id,
      );
    }
     else if (this.village_id > 0) {
      this.AshaEmployeeRecordList = this.AshaEmployeeRecordLookup.filter(
        (v) => v.p.village_id === this.village_id,
      );
    } else {
      this.AshaEmployeeRecordList = [];
    }
     if (this.AshaEmployeeRecordList.length == 1) {
        this.asha_employee_record_id = this.AshaEmployeeRecordList[0].p.id;
        this.IsAshaEmployeeRecordDisabled = true;
      } else {
        this.IsAshaEmployeeRecordDisabled = false;
      }
  }

  //  Dropdown change event handlers - Reset dependent dropdowns and notify component
  onStateChanged(e: any) {
    this.state_id = Number(e.value) || 0;

    // Reset all dependent selections
    this.zone_id = 0;
    this.district_id = 0;
    this.block_id = 0;
    this.bcm_post_id = 0;
    this.phc_id = 0;
    this.af_employee_record_id = 0;
    this.af_post_id = 0;
    this.sc_id = 0;
    this.village_id = 0;
    this.asha_employee_record_id = 0;

    // reset lists
    this.ZoneList = [];
    this.DistrictList = [];
    this.BlockList = [];
    this.BCMPostList = [];
    this.PHCList = [];
    this.AFEmployeeRecordList = [];
    this.AFPostList = [];
    this.SCList = [];
    this.VillageList = [];
    this.AshaEmployeeRecordList = [];

    this.IsZoneDisabled = false
    this.IsDistrictDisabled = false
    this.IsBlockDisabled = false
    this.IsBCMPostDisabled = false
    this.IsPHCDisabled = false
    this.IsAFPostDisabled = false
    this.IsAFEmployeeRecordDisabled = false
    this.IsSCDisabled = false
    this.IsVillageDisabled = false
    this.IsAshaEmployeeRecordDisabled = false

    this.applyFilters();
    this.notifyFilterChanged();
  }

  onZoneChanged(e: any) {
    this.zone_id = Number(e.value) || 0;

    // Reset all dependent selections
    this.district_id = 0;
    this.block_id = 0;
    this.bcm_post_id = 0;
    this.phc_id = 0;
    this.af_employee_record_id = 0;
    this.af_post_id = 0;
    this.sc_id = 0;
    this.village_id = 0;
    this.asha_employee_record_id = 0;

    // reset lists
    this.DistrictList = [];
    this.BlockList = [];
    this.BCMPostList = [];
    this.PHCList = [];
    this.AFEmployeeRecordList = [];
    this.AFPostList = [];
    this.SCList = [];
    this.VillageList = [];
    this.AshaEmployeeRecordList = [];

    this.IsDistrictDisabled = false
    this.IsBlockDisabled = false
    this.IsBCMPostDisabled = false
    this.IsPHCDisabled = false
    this.IsAFPostDisabled = false
    this.IsAFEmployeeRecordDisabled = false
    this.IsSCDisabled = false
    this.IsVillageDisabled = false
    this.IsAshaEmployeeRecordDisabled = false

    this.applyFilters();
    this.notifyFilterChanged();
  }

  onDistrictChanged(e: any) {
    this.district_id = Number(e.value) || 0;

    // Reset all dependent selections
    this.block_id = 0;
    this.bcm_post_id = 0;
    this.phc_id = 0;
    this.af_employee_record_id = 0;
    this.af_post_id = 0;
    this.sc_id = 0;
    this.village_id = 0;
    this.asha_employee_record_id = 0;

    // reset lists
    this.BlockList = [];
    this.BCMPostList = [];
    this.PHCList = [];
    this.AFEmployeeRecordList = [];
    this.AFPostList = [];
    this.SCList = [];
    this.VillageList = [];
    this.AshaEmployeeRecordList = [];

    this.IsBlockDisabled = false
    this.IsBCMPostDisabled = false
    this.IsPHCDisabled = false
    this.IsAFPostDisabled = false
    this.IsAFEmployeeRecordDisabled = false
    this.IsSCDisabled = false
    this.IsVillageDisabled = false
    this.IsAshaEmployeeRecordDisabled = false


    this.applyFilters();
    // notify AFTER reset
    this.notifyFilterChanged();
  }

  onBlockChanged(e: any) {
    this.block_id = Number(e.value) || 0;
    // Reset all dependent selections
    this.bcm_post_id = 0;
    this.phc_id = 0;
    this.af_post_id = 0;
    this.af_employee_record_id = 0;
    this.sc_id = 0;
    this.village_id = 0;
    this.asha_employee_record_id = 0;

    // reset lists
    this.BCMPostList = [];
    this.PHCList = [];
    this.AFEmployeeRecordList = [];
    this.AFPostList = [];
    this.SCList = [];
    this.VillageList = [];
    this.AshaEmployeeRecordList = [];

    this.IsBCMPostDisabled = false
    this.IsPHCDisabled = false
    this.IsAFPostDisabled = false
    this.IsAFEmployeeRecordDisabled = false
    this.IsSCDisabled = false
    this.IsVillageDisabled = false
    this.IsAshaEmployeeRecordDisabled = false

    this.applyFilters();
    this.notifyFilterChanged();
  }

  onBCMPostChanged(e: any) {
    this.bcm_post_id = Number(e.value) || 0;

    // Reset all dependent selections
    this.phc_id = 0;
    this.af_post_id = 0;
    this.af_employee_record_id = 0;
    this.sc_id = 0;
    this.village_id = 0;
    this.asha_employee_record_id = 0;

    // reset lists
    this.PHCList = [];
    this.AFEmployeeRecordList = [];
    this.AFPostList = [];
    this.SCList = [];
    this.VillageList = [];
    this.AshaEmployeeRecordList = [];

    this.IsPHCDisabled = false
    this.IsAFPostDisabled = false
    this.IsAFEmployeeRecordDisabled = false
    this.IsSCDisabled = false
    this.IsVillageDisabled = false
    this.IsAshaEmployeeRecordDisabled = false

    this.applyFilters();
    this.notifyFilterChanged();
  }

  onAFPostChanged(e: any) {
    this.af_post_id = Number(e.value) || 0;

    // Reset dependent selections
    this.asha_employee_record_id = 0;

    // reset lists
    this.AshaEmployeeRecordList = [];

    this.IsAshaEmployeeRecordDisabled = false

    this.applyFilters();
    this.notifyFilterChanged();
  }

  onAshaEmployeeRecordChanged (e: any) {
  console.log('e :', e.value);
    this.asha_employee_record_id = Number(e.value) || 0;
  }

  onPHCChanged(e: any) {
    this.phc_id = Number(e.value) || 0;

    // Reset all dependent selections
    this.af_post_id = 0;
    this.af_employee_record_id = 0;
    this.sc_id = 0;
    this.village_id = 0;
    this.asha_employee_record_id = 0;

    // reset lists
    this.AFPostList = [];
    this.AFEmployeeRecordList = [];
    this.SCList = [];
    this.VillageList = [];
    this.AshaEmployeeRecordList = [];

    this.IsAFPostDisabled = false
    this.IsAFEmployeeRecordDisabled = false
    this.IsSCDisabled = false
    this.IsVillageDisabled = false
    this.IsAshaEmployeeRecordDisabled = false

    this.applyFilters();
    this.notifyFilterChanged();
  }

  onAFEmployeeRecordChanged(e: any) {
    this.af_employee_record_id = Number(e.value) || 0;

    this.asha_employee_record_id = 0;

    // reset lists
    this.AshaEmployeeRecordList = [];

    this.IsAshaEmployeeRecordDisabled = false

    this.applyFilters();
    this.notifyFilterChanged();
  }

  onSCChanged(e: any) {
    this.sc_id = Number(e.value) || 0;

    // Reset all dependent selections
    this.village_id = 0;
    this.asha_employee_record_id = 0;

    // reset lists
    this.VillageList = [];
    this.AshaEmployeeRecordList = [];

    this.IsVillageDisabled = false
    this.IsAshaEmployeeRecordDisabled = false

    this.applyFilters();
    this.notifyFilterChanged();
  }

  onVillageChanged(e: any) {
    this.village_id = Number(e.value) || 0;

    // Reset dependent selection
    this.asha_employee_record_id = 0;

    // reset lists
    this.IsAshaEmployeeRecordDisabled = false

    this.applyFilters();
    this.notifyFilterChanged();
  }

  onAshaChanged(e: any) {
    this.asha_employee_record_id = Number(e.value) || 0;

    this.applyFilters();
    this.notifyFilterChanged();
  }

  // ✅ Reset all filters
  resetFilters() {
    // ✅ All Ref Blank
    this.financial_year_id = 0;
    this.month = 0;
    this.state_id = 0;
    this.zone_id = 0;
    this.district_id = 0;
    this.block_id = 0;
    this.bcm_post_id = 0;
    this.phc_id = 0;
    this.af_post_id = 0;
    this.af_employee_record_id = 0;
    this.sc_id = 0;
    this.village_id = 0;
    this.asha_employee_record_id = 0;

    // ✅ All List Blank
    this.StateList = [];
    this.ZoneList = [];
    this.DistrictList = [];
    this.BlockList = [];
    this.BCMPostList = [];
    this.AFEmployeeRecordList = [];
    this.PHCList = [];
    this.AFPostList = [];
    this.SCList = [];
    this.VillageList = [];
    this.AshaEmployeeRecordList = [];

    // ✅ All Disabled states False
    this.IsStateDisabled = false;
    this.IsZoneDisabled = false;
    this.IsDistrictDisabled = false;
    this.IsBlockDisabled = false;
    this.IsBCMPostDisabled = false;
    this.IsPHCDisabled = false;
    this.IsAFPostDisabled = false;
    this.IsSCDisabled = false;
    this.IsVillageDisabled = false;
    this.IsAshaEmployeeRecordDisabled = false;
    this.IsAFEmployeeRecordDisabled = false;
    // ✅ Emit reset state
  }

  registerOnFilterChange(callback: () => void) {
    this.filterChangeCallback = callback;
  }

  // private notifyFilterChanged() {
  //   if (this.isInitializing) {
  //     return;
  //   }
  //   this.filterChangeCallback?.();
  // }

  private isNavigating = false;

setNavigating(value: boolean) {
  this.isNavigating = value;
}

private notifyFilterChanged() {
  if (this.isInitializing || this.isNavigating) {
    return;
  }
  this.filterChangeCallback?.();
}
}

// ✅ Load data from API (your existing method - keeping it as is)
// async LoadFilterDataUPTOBlockLevel( UpTO: number,
//   errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance()
//     .GlobalUIErrorHandler
// ): Promise<ResponseProps> {
//   let response = new ResponseProps();
//   console.log('response transaction :', response);

// //  Disable change notifications during data load to prevent cascading API calls
// this.isInitializing = true;

//   try {
//         // Fetch all Asha records with hierarchy data from API
//     var ashaData = await AshaEmployeeRecord.FetchEntireListForReportFilter(
//         async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg)
//       );
//       console.log('`ashaData` :', ashaData);

//     if (ashaData.length === 0) {
//       await this.uiUtils.showErrorMessage("Error", "No Asha Found");
//       return response;
//     }

//     // Sort Asha Employee Record List alphabetically by name
//     this.AshaEmployeeRecordLookup = ashaData.sort((a, b) =>
//       (a.p.asha_full_name || "").localeCompare(b.p.asha_full_name || "")
//     );
//     this.AshaEmployeeRecordList = [...this.AshaEmployeeRecordLookup];

//   //  Extract unique States from Asha data and build State list
//     const stateMap = new Map();
//     ashaData.forEach((asha) => {
//       if (asha.p.state_id > 0 && !stateMap.has(asha.p.state_id)) {
//         let state = State.CreateNewInstance();
//         state.p.id = asha.p.state_id;
//         state.p.name_en = asha.p.state_name_en;
//         state.p.name_mr = asha.p.state_name_mr;
//         stateMap.set(asha.p.state_id, state);
//       }
//     });
//     if (Array.from(stateMap.values()).length > 0) {
//       this.StateLookup = Array.from(stateMap.values()).sort((a, b) =>
//           (a.p.name_en || "").localeCompare(b.p.name_en || "")
//   );
//   console.log('   this.StateLookup serv:',    this.StateLookup);
//       this.StateList = [...this.StateLookup];
//     }

//   //  Extract unique Zones from Asha data and build Zone list
//     const zoneMap = new Map();
//     ashaData.forEach((asha) => {
//       if (asha.p.zone_id && !zoneMap.has(asha.p.zone_id)) {
//         let zone = Zone.CreateNewInstance();
//         zone.p.id = asha.p.zone_id;
//         zone.p.Name = asha.p.ZoneName;
//         zone.p.state_id = asha.p.state_id;
//         zoneMap.set(asha.p.zone_id, zone);
//       }
//     });
//     if (Array.from(zoneMap.values()).length > 0) {
//       this.ZoneLookup = Array.from(zoneMap.values()).sort((a, b) =>
//           (a.p.Name || "").localeCompare(b.p.Name || "")
//   );
//   console.log(' this.ZoneLookup  serv:',  this.ZoneLookup );
//       this.ZoneList = [...this.ZoneLookup];
//     }

//   //  Extract unique Districts from Asha data and build District list
//     const districtMap = new Map();
//     ashaData.forEach((asha) => {
//       if (asha.p.district_id && !districtMap.has(asha.p.district_id)) {
//         let district = District.CreateNewInstance();
//         district.p.id = asha.p.district_id;
//         district.p.name_en = asha.p.DistrictNameInEnglish;
//         district.p.name_mr = asha.p.DistrictNameInMarathi;
//         district.p.zone_id = asha.p.zone_id;
//         district.p.state_id = asha.p.state_id;
//         districtMap.set(asha.p.district_id, district);
//       }
//     });
//     if (Array.from(districtMap.values()).length > 0) {
//       this.DistrictLookup = Array.from(districtMap.values()).sort(
//           (a, b) => (a.p.name_en || "").localeCompare(b.p.name_en || "")
//       );
//       console.log('this.DistrictLookup serv :', this.DistrictLookup);
//       this.DistrictList = [...this.DistrictLookup];
//     }

//   //  Extract unique Blocks from Asha data and build Block list
//     const blockMap = new Map();
//     ashaData.forEach((asha) => {
//       if (asha.p.block_id && !blockMap.has(asha.p.block_id)) {
//         let block = Block.CreateNewInstance();
//         block.p.id = asha.p.block_id;
//         block.p.name_en = asha.p.BlockNameInEnglish;
//         block.p.name_mr = asha.p.BlockNameInMarathi;
//         block.p.district_id = asha.p.district_id;
//         block.p.zone_id = asha.p.zone_id;
//         block.p.state_id = asha.p.state_id;
//         blockMap.set(asha.p.block_id, block);
//       }
//     });
//     if (Array.from(blockMap.values()).length > 0) {
//       this.BlockLookup = Array.from(blockMap.values()).sort((a, b) =>
//           (a.p.name_en || "").localeCompare(b.p.name_en || "")
//   );
//   console.log(' this.BlockLookup :',  this.BlockLookup);
//       this.BlockList = [...this.BlockLookup];
//     }

//   //   Auto-select and disable dropdowns with only one option
//     if (this.StateLookup.length === 1) {
//       this.state_id = this.StateLookup[0].p.id;
//       this.IsStateDisabled = true;
//     }
//     if (this.ZoneLookup.length === 1) {
//       this.zone_id = this.ZoneLookup[0].p.id;
//       this.IsZoneDisabled = true;
//     }
//     if (this.DistrictLookup.length === 1) {
//       this.district_id = this.DistrictLookup[0].p.id;
//       this.IsDistrictDisabled = true;
//     }
//     if (this.BlockLookup.length === 1) {
//       this.block_id = this.BlockLookup[0].p.id;
//       this.IsBlockDisabled = true;
//     }

//     response.state_id = this.state_id;
//     response.zone_id = this.zone_id;
//     response.district_id = this.district_id;
//     response.block_id = this.block_id;

//     return response;
//   } catch (error) {
//     console.error("Error loading data:", error);
//     await this.uiUtils.showErrorMessage(
//       "Error",
//       "Failed to load hierarchy data"
//     );
//     return response;

//   } finally {
//   //  Re-enable change notifications after 100ms (ensures all UI bindings complete)
//   setTimeout(() => {
//     this.isInitializing = false;
//     console.log('✅ Initialization complete - notifications enabled');
//   }, 100);
// }
// }

// import { Injectable } from "@angular/core";
// import { AshaEmployeeRecord } from "../classes/domain/entities/website/masters/asha/asha-employee-record/ashaemployeerecord";
// import { State } from "../classes/domain/entities/website/masters/state/state";
// import { Zone } from "../classes/domain/entities/website/masters/zone/zone";
// import { District } from "../classes/domain/entities/website/masters/district/district";
// import { Block } from "../classes/domain/entities/website/masters/block/block";
// import { PHC } from "../classes/domain/entities/website/masters/phc/phc";
// import { SC } from "../classes/domain/entities/website/masters/sc/sc";
// import { Village } from "../classes/domain/entities/website/masters/village/village";
// import { UIUtils } from "./uiutils.service";
// import { BFEmployeeRecord } from "../classes/domain/entities/website/masters/bf/bf-employee-record/bfemployeerecord";
// import { Roles } from "../classes/infrastructure/enums";
// import { DHOEmployeeRecord } from "../classes/domain/entities/website/masters/dho/dho-employee-record/dhoemployeerecord";
// import { BCMEmployeeRecord } from "../classes/domain/entities/website/masters/bcm/bcm-employee-record/bcmemployeerecord";
// import { AFPostMaster } from "../classes/domain/entities/website/masters/sanctioned-posts/af-post/afpost";

// export class ReportResponseProps {
//   state_id: number[] = [];
//   zone_id: number[] = [];
//   district_id: number[] = [];
//   block_id: number[] = [];
//   phc_id: number[] = [];
//   af_post_id: number[] = [];
//   sc_id: number[] = [];
//   village_id: number[] = [];
//   asha_employee_record_id: number[] = [];
// }

// @Injectable({
//   providedIn: "root",
// })
// export class AshaReportFilterService {
//   StateList: State[] = [];
//   ZoneList: Zone[] = [];
//   DistrictList: District[] = [];
//   BlockList: Block[] = [];
//   PHCList: PHC[] = [];
//   AFPostList: AFPostMaster[] = [];
//   SCList: SC[] = [];
//   VillageList: Village[] = [];
//   AshaEmployeeRecordList: AshaEmployeeRecord[] = [];
//   ReportStateList: State[] = [];
//   ReportZoneList: Zone[] = [];
//   ReportDistrictList: District[] = [];
//   ReportBlockList: Block[] = [];
//   ReportAFPostList: AFPostMaster[] = [];
//   ReportPHCList: PHC[] = [];
//   ReportSCList: SC[] = [];
//   ReportVillageList: Village[] = [];
//   ReportAshaEmployeeRecordList: AshaEmployeeRecord[] = [];

//   state_id: number[] = [];
//   zone_id: number[] = [];
//   district_id: number[] = [];
//   block_id: number[] = [];
//   phc_id: number[] = [];
//   af_post_id: number[] = [];
//   sc_id: number[] = [];
//   village_id: number[] = [];
//   asha_employee_record_id: number[] = [];

//   IsStateDisabled: boolean = false;
//   IsZoneDisabled: boolean = false;
//   IsDistrictDisabled: boolean = false;
//   IsBlockDisabled: boolean = false;
//   IsPHCDisabled: boolean = false;
//   IsAFPostDisabled: boolean = false;
//   IsSCDisabled: boolean = false;
//   IsVillageDisabled: boolean = false;
//   IsAshaEmployeeRecordDisabled: boolean = false;

//   constructor(private uiUtils: UIUtils) {}
//   async LoadReportFilterData(
//     errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance()
//       .GlobalUIErrorHandler
//   ): Promise<ReportResponseProps> {
//     let response = new ReportResponseProps();

//     try {
//       // 1️⃣ Fetch all asha Data
//       var ashaData = await AshaEmployeeRecord.FetchEntireListForReportFilter(
//         async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg)
//       );
//       console.log("ashaData:", ashaData);

//       if (ashaData.length === 0) {
//         await this.uiUtils.showErrorMessage("Error", "No Asha Found");
//         return response;
//       }
//       // ✅ Sort A → Z
//       ashaData.sort((a, b) => a.p.asha_full_name.localeCompare(b.p.asha_full_name));
//       this.ReportAshaEmployeeRecordList = ashaData;
//       this.AshaEmployeeRecordList = ashaData;
//       console.log("this.AshaEmployeeRecordList :", this.AshaEmployeeRecordList);

//       // 7️⃣ Extract and build State List (deduplicated by state_id)
//       const stateMap = new Map();
//       ashaData.forEach((asha) => {
//         if (asha.p.state_id > 0 && !stateMap.has(asha.p.state_id)) {
//           let state = State.CreateNewInstance();
//           state.p.id = asha.p.state_id;
//           state.p.name_en = asha.p.state_name_en;
//           state.p.name_mr = asha.p.state_name_mr;
//           stateMap.set(asha.p.state_id, state);
//         }
//       });

//       if (Array.from(stateMap.values()).length > 0) {
//         this.ReportStateList = this.sortByName(
//           Array.from(stateMap.values()),
//           (s) => s.p.name_en
//         );
//         this.StateList = [...this.ReportStateList];
//         // this.ReportStateList = Array.from(stateMap.values());
//         // this.StateList = this.ReportStateList;
//       }

//       // 6️⃣ Extract and build Zone List (deduplicated by zone_id)
//       const zoneMap = new Map();
//       ashaData.forEach((asha) => {
//         if (asha.p.zone_id && !zoneMap.has(asha.p.zone_id)) {
//           let zone = Zone.CreateNewInstance();
//           zone.p.id = asha.p.zone_id;
//           zone.p.Name = asha.p.ZoneName;
//           zone.p.state_id = asha.p.state_id;
//           zoneMap.set(asha.p.zone_id, zone);
//         }
//       });

//       if (Array.from(zoneMap.values()).length > 0) {
//         this.ReportZoneList = this.sortByName(
//           Array.from(zoneMap.values()),
//           (z) => z.p.Name
//         );
//         this.ZoneList = [...this.ReportZoneList];
//         // this.ReportZoneList = Array.from(zoneMap.values());
//         // this.ZoneList = this.ReportZoneList;
//       }

//       // 5️⃣ Extract and build District List (deduplicated by district_id)
//       const districtMap = new Map();
//       ashaData.forEach((asha) => {
//         if (asha.p.district_id && !districtMap.has(asha.p.district_id)) {
//           let district = District.CreateNewInstance();
//           district.p.id = asha.p.district_id;
//           district.p.name_en = asha.p.DistrictNameInEnglish;
//           district.p.name_mr = asha.p.DistrictNameInMarathi;
//           district.p.zone_id = asha.p.zone_id;
//           district.p.state_id = asha.p.state_id;
//           districtMap.set(asha.p.district_id, district);
//         }
//       });

//       if (Array.from(districtMap.values()).length > 0) {
//         this.ReportDistrictList = this.sortByName(
//           Array.from(districtMap.values()),
//           (d) => d.p.name_en
//         );
//         this.DistrictList = [...this.ReportDistrictList];
//         // this.ReportDistrictList = Array.from(districtMap.values());
//         // this.DistrictList = this.ReportDistrictList;
//       }

//       // 4️⃣ Extract and build Block List (deduplicated by block_id)
//       const blockMap = new Map();
//       ashaData.forEach((asha) => {
//         if (asha.p.block_id && !blockMap.has(asha.p.block_id)) {
//           let block = Block.CreateNewInstance();
//           block.p.id = asha.p.block_id;
//           block.p.name_en = asha.p.BlockNameInEnglish;
//           block.p.name_mr = asha.p.BlockNameInMarathi;
//           block.p.district_id = asha.p.district_id;
//           block.p.zone_id = asha.p.zone_id;
//           block.p.state_id = asha.p.state_id;
//           blockMap.set(asha.p.block_id, block);
//         }
//       });

//       if (Array.from(blockMap.values()).length > 0) {
//         this.ReportBlockList = this.sortByName(
//           Array.from(blockMap.values()),
//           (b) => b.p.name_en
//         );
//         this.BlockList = [...this.ReportBlockList];
//         // this.ReportBlockList = Array.from(blockMap.values());
//         // this.BlockList = this.ReportBlockList;
//       }

//       // 3️⃣ Extract and build PHC List (deduplicated by phc_id)
//       const phcMap = new Map();
//       ashaData.forEach((asha) => {
//         if (asha.p.phc_id && !phcMap.has(asha.p.phc_id)) {
//           let phc = PHC.CreateNewInstance();
//           phc.p.id = asha.p.phc_id;
//           phc.p.Name = asha.p.PHCName;
//           phc.p.block_id = asha.p.block_id;
//           phc.p.district_id = asha.p.district_id;
//           phc.p.zone_id = asha.p.zone_id;
//           phc.p.state_id = asha.p.state_id;
//           phcMap.set(asha.p.phc_id, phc);
//         }
//       });

//       if (Array.from(phcMap.values()).length > 0) {
//         this.ReportPHCList = this.sortByName(
//           Array.from(phcMap.values()),
//           (p) => p.p.Name
//         );
//         this.PHCList = [...this.ReportPHCList];
//         // this.ReportPHCList = Array.from(phcMap.values());
//         // this.PHCList = this.ReportPHCList;
//       }
//       // 3️⃣ Extract and build AF Post List (deduplicated by af_post_id)
//       const afpostMap = new Map();
//       ashaData.forEach((asha) => {
//         if (
//           asha.p.UnderSupervision &&
//           !afpostMap.has(asha.p.UnderSupervision)
//         ) {
//           let afpost = AFPostMaster.CreateNewInstance();
//           afpost.p.id = asha.p.UnderSupervision;
//           afpost.p.Name = asha.p.AFPostName;
//           afpost.p.block_id = asha.p.block_id;
//           afpost.p.district_id = asha.p.district_id;
//           afpost.p.zone_id = asha.p.zone_id;
//           afpost.p.state_id = asha.p.state_id;
//           afpost.p.block_id = asha.p.block_id;
//           afpost.p.phc_id = asha.p.phc_id;
//           // afpost.p.af_post_id= asha.p.id
//           afpostMap.set(asha.p.UnderSupervision, afpost);
//         }
//       });

//       if (Array.from(afpostMap.values()).length > 0) {
//         this.ReportAFPostList = this.sortByName(
//           Array.from(afpostMap.values()),
//           (a) => a.p.Name
//         );
//         this.AFPostList = [...this.ReportAFPostList];
//         // this.ReportAFPostList = Array.from(afpostMap.values());
//         // this.AFPostList = this.ReportAFPostList;
//         console.log("this.AFPostList :", this.AFPostList);
//       }

//       // 2️⃣ Extract and build SC List (deduplicated by sc_id)
//       const scMap = new Map();
//       ashaData.forEach((asha) => {
//         if (asha.p.sc_id && !scMap.has(asha.p.sc_id)) {
//           let sc = SC.CreateNewInstance();
//           sc.p.id = asha.p.sc_id;
//           sc.p.Name = asha.p.SCName;
//           sc.p.phc_id = asha.p.phc_id;
//           sc.p.block_id = asha.p.block_id;
//           sc.p.district_id = asha.p.district_id;
//           sc.p.zone_id = asha.p.zone_id;
//           sc.p.state_id = asha.p.state_id;
//           scMap.set(asha.p.sc_id, sc);
//         }
//       });

//       if (Array.from(scMap.values()).length > 0) {
//         this.ReportSCList = this.sortByName(
//           Array.from(scMap.values()),
//           (s) => s.p.Name
//         );
//         this.SCList = [...this.ReportSCList];
//         // this.ReportSCList = Array.from(scMap.values());
//         // this.SCList = this.ReportSCList;
//       }

//       // 2️⃣ Extract and build SC List (deduplicated by sc_id)
//       const villageMap = new Map();
//       ashaData.forEach((asha) => {
//         if (asha.p.village_id && !villageMap.has(asha.p.village_id)) {
//           let village = Village.CreateNewInstance();
//           village.p.id = asha.p.village_id;
//           village.p.name_en = asha.p.VillageNameInEnglish;
//           village.p.name_mr = asha.p.VillageNameInMarathi;
//           village.p.phc_id = asha.p.phc_id;
//           village.p.block_id = asha.p.block_id;
//           village.p.district_id = asha.p.district_id;
//           village.p.zone_id = asha.p.zone_id;
//           village.p.state_id = asha.p.state_id;
//           village.p.sc_id = asha.p.sc_id;
//           villageMap.set(asha.p.village_id, village);
//         }
//       });

//       if (Array.from(villageMap.values()).length > 0) {
//         this.ReportVillageList = this.sortByName(
//           Array.from(villageMap.values()),
//           (v) => v.p.name_en
//         );
//         this.VillageList = [...this.ReportVillageList];
//         // this.ReportVillageList = Array.from(villageMap.values());
//         // this.VillageList = this.ReportVillageList;
//       }

//       // ✅ Auto-select and disable if only one option exists
//       // STATE
//       if (this.ReportStateList.length === 1) {
//         this.state_id.push(this.ReportStateList[0].p.id);
//         this.IsStateDisabled = true;
//       } else {
//         this.state_id = [];
//         this.IsStateDisabled = false;
//       }

//       // ZONE
//       if (this.ReportZoneList.length === 1) {
//         this.zone_id.push(this.ReportZoneList[0].p.id);
//         this.IsZoneDisabled = true;
//       } else {
//         this.zone_id = [];
//         this.IsZoneDisabled = false;
//       }

//       // DISTRICT
//       if (this.ReportDistrictList.length === 1) {
//         this.district_id.push(this.ReportDistrictList[0].p.id);
//         this.IsDistrictDisabled = true;
//       } else {
//         this.district_id = [];
//         this.IsDistrictDisabled = false;
//       }

//       // BLOCK
//       if (this.ReportBlockList.length === 1) {
//         this.block_id.push(this.ReportBlockList[0].p.id);
//         this.IsBlockDisabled = true;
//       } else {
//         this.block_id = [];
//         this.IsBlockDisabled = false;
//       }

//       // PHC
//       if (this.ReportPHCList.length === 1) {
//         this.phc_id.push(this.ReportPHCList[0].p.id);
//         this.IsPHCDisabled = true;
//       } else {
//         this.phc_id = [];
//         this.IsPHCDisabled = false;
//       }

//       // AF Post
//       if (this.ReportAFPostList.length === 1) {
//         this.af_post_id.push(this.ReportAFPostList[0].p.id);
//         this.IsAFPostDisabled = true;
//       } else {
//         this.af_post_id = [];
//         this.IsAFPostDisabled = false;
//       }

//       // SC
//       console.log("this.ReportSCList :", this.ReportSCList);
//       if (this.ReportSCList.length === 1) {
//         this.sc_id.push(this.ReportSCList[0].p.id);
//         this.IsSCDisabled = true;
//       } else {
//         this.sc_id = [];
//         this.IsSCDisabled = false;
//       }

//       // VILLAGE
//       if (this.VillageList.length === 1) {
//         this.village_id.push(this.VillageList[0].p.id);
//         this.IsVillageDisabled = true;
//       } else {
//         this.village_id = [];
//         this.IsVillageDisabled = false;
//       }

//       // Asha
//       if (ashaData.length === 1) {
//         this.asha_employee_record_id.push(ashaData[0].p.id);
//         this.IsAshaEmployeeRecordDisabled = true;
//       } else {
//         this.asha_employee_record_id = [];
//         this.IsAshaEmployeeRecordDisabled = false;
//       }

//       console.log("SuperAdmin Data Loaded Summary:", {
//         States: this.StateList.length,
//         Zones: this.ZoneList.length,
//         Districts: this.DistrictList.length,
//         Blocks: this.BlockList.length,
//         PHCs: this.PHCList.length,
//         SCs: this.SCList.length,
//         Villages: this.VillageList.length,
//       });

//       response.state_id = this.state_id;
//       response.zone_id = this.zone_id;
//       response.district_id = this.district_id;
//       response.block_id = this.block_id;
//       response.phc_id = this.phc_id;
//       response.af_post_id = this.af_post_id;
//       response.sc_id = this.sc_id;
//       response.village_id = this.village_id;
//       response.asha_employee_record_id = this.asha_employee_record_id;

//       return response;
//     } catch (error) {
//       console.error("Error loading SuperAdmin data:", error);
//       await this.uiUtils.showErrorMessage(
//         "Error",
//         "Failed to load hierarchy data"
//       );
//       return response;
//     }
//   }

//   onStateChanged(e: any) {
//     // Ignore the first time it fires on load
//     // if (
//     //   // !this.IsNewEntity &&
//     //   (e.previousValue === null ||
//     //     e.previousValue === undefined ||
//     //     e.previousValue === 0)
//     // ) {
//     //   return;
//     // }
//     // const valueArray: number[] = Array.isArray(e.value) ? e.value : [e.value];
//     // console.log(valueArray);
//     // if(valueArray.length > 0){
//     //   this.StateList = [];
//     //   this.StateList = this.ReportStateList.filter(v=> valueArray.includes(v.p.zone_id));
//     // }
//     // else{
//     //   this.StateList = this.ReportStateList;
//     // }
//   }

//   onZoneChanged(e: any) {
//     // Ignore the first time it fires on load
//     if (
//       // !this.IsNewEntity &&
//       e.previousValue === null ||
//       e.previousValue === undefined ||
//       e.previousValue === 0
//     ) {
//       return;
//     }

//     const valueArray: number[] = Array.isArray(e.value) ? e.value : [e.value];
//     if (valueArray.length > 0) {
//       this.DistrictList = [];
//       this.DistrictList = this.ReportDistrictList.filter((v) =>
//         valueArray.includes(v.p.zone_id)
//       );
//     } else {
//       this.DistrictList = this.ReportDistrictList;
//     }
//   }

//   onDistrictChanged(e: any) {
//     // Ignore first auto-trigger on form load
//     if (
//       // !this.IsNewEntity &&
//       e.previousValue === null ||
//       e.previousValue === undefined ||
//       e.previousValue === 0
//     ) {
//       return;
//     }

//     const valueArray: number[] = Array.isArray(e.value) ? e.value : [e.value];
//     if (valueArray.length > 0) {
//       this.BlockList = [];
//       this.BlockList = this.ReportBlockList.filter((v) =>
//         valueArray.includes(v.p.district_id)
//       );
//       if (this.BlockList.length > 0) {
//         this.PHCList = [];
//         this.PHCList = this.ReportPHCList.filter((v) =>
//           this.BlockList.map((e) => e.p.id).includes(v.p.block_id)
//         );
//         if (this.PHCList.length > 0) {
//           this.AFPostList = [];
//           this.AFPostList = this.ReportAFPostList.filter((v) =>
//             this.PHCList.map((e) => e.p.id).includes(v.p.phc_id)
//           );
//           if (this.PHCList.length > 0) {
//             this.SCList = [];
//             this.SCList = this.ReportSCList.filter((v) =>
//               this.PHCList.map((e) => e.p.id).includes(v.p.phc_id)
//             );
//             if (this.SCList.length > 0) {
//               this.VillageList = this.ReportVillageList.filter((v) =>
//                 this.SCList.map((e) => e.p.id).includes(v.p.sc_id)
//               );
//               if (this.VillageList.length > 0) {
//                 this.AshaEmployeeRecordList =
//                   this.ReportAshaEmployeeRecordList.filter((v) =>
//                     this.VillageList.map((e) => e.p.id).includes(
//                       v.p.village_id
//                     )
//                   );
//               } else {
//                 this.AshaEmployeeRecordList = this.ReportAshaEmployeeRecordList;
//               }
//             } else {
//               this.VillageList = this.ReportVillageList;
//             }
//           } else {
//             this.SCList = this.ReportSCList;
//           }
//         } else {
//           this.AFPostList = this.ReportAFPostList;
//         }
//       } else {
//         this.PHCList = this.ReportPHCList;
//       }
//     } else {
//       this.BlockList = this.ReportBlockList;
//     }
//   }

//   onBlockChanged(e: any) {
//     // Ignore first auto-trigger on form load
//     if (
//       // !this.IsNewEntity &&
//       e.previousValue === null ||
//       e.previousValue === undefined ||
//       e.previousValue === 0
//     ) {
//       return;
//     }

//     const valueArray: number[] = Array.isArray(e.value) ? e.value : [e.value];
//     if (valueArray.length > 0) {
//       this.PHCList = [];
//       this.PHCList = this.ReportPHCList.filter((v) =>
//         valueArray.includes(v.p.block_id)
//       );
//       if (this.PHCList.length > 0) {
//         this.SCList = [];
//         this.SCList = this.ReportSCList.filter((v) =>
//           this.PHCList.map((e) => e.p.id).includes(v.p.phc_id)
//         );
//         if (this.PHCList.length > 0) {
//           this.AFPostList = [];
//           this.AFPostList = this.ReportAFPostList.filter((v) =>
//             this.PHCList.map((e) => e.p.id).includes(v.p.phc_id)
//           );
//           if (this.SCList.length > 0) {
//             this.VillageList = this.ReportVillageList.filter((v) =>
//               this.SCList.map((e) => e.p.id).includes(v.p.sc_id)
//             );
//             if (this.VillageList.length > 0) {
//               this.AshaEmployeeRecordList =
//                 this.ReportAshaEmployeeRecordList.filter((v) =>
//                   this.VillageList.map((e) => e.p.id).includes(v.p.village_id)
//                 );
//             } else {
//               this.AshaEmployeeRecordList = this.ReportAshaEmployeeRecordList;
//             }
//           } else {
//             this.VillageList = this.ReportVillageList;
//           }
//         } else {
//           this.SCList = this.ReportSCList;
//         }
//       } else {
//         this.AFPostList = this.ReportAFPostList;
//       }
//     } else {
//       this.PHCList = this.ReportPHCList;
//     }
//   }

//   onPHCChanged(e: any) {
//     // Ignore first auto-trigger on form load
//     if (
//       // !this.IsNewEntity &&
//       e.previousValue === null ||
//       e.previousValue === undefined ||
//       e.previousValue === 0
//     ) {
//       return;
//     }

//     const valueArray: number[] = Array.isArray(e.value) ? e.value : [e.value];
//     if (valueArray.length > 0) {
//       this.AFPostList = [];
//       this.AFPostList = this.ReportAFPostList.filter((v) =>
//         valueArray.includes(v.p.phc_id)
//       );
//       if (this.PHCList.length > 0) {
//         this.SCList = [];
//         this.SCList = this.ReportSCList.filter((v) =>
//           valueArray.includes(v.p.phc_id)
//         );
//         if (this.SCList.length > 0) {
//           this.VillageList = [];
//           this.VillageList = this.ReportVillageList.filter((v) =>
//             this.SCList.map((e) => e.p.id).includes(v.p.sc_id)
//           );
//           if (this.VillageList.length > 0) {
//             this.AshaEmployeeRecordList =
//               this.ReportAshaEmployeeRecordList.filter((v) =>
//                 this.VillageList.map((e) => e.p.id).includes(v.p.village_id)
//               );
//           } else {
//             this.AshaEmployeeRecordList = this.ReportAshaEmployeeRecordList;
//           }
//         } else {
//           this.VillageList = this.ReportVillageList;
//         }
//       } else {
//         this.SCList = this.ReportSCList;
//       }
//     } else {
//       this.AFPostList = this.ReportAFPostList;
//     }
//   }

//   onAFPostChanged(e: any) {
//     // Ignore first auto-trigger on form load
//     if (
//       // !this.IsNewEntity &&
//       e.previousValue === null ||
//       e.previousValue === undefined ||
//       e.previousValue === 0
//     ) {
//       return;
//     }

//     const valueArray: number[] = Array.isArray(e.value) ? e.value : [e.value];
//     if (valueArray.length > 0) {
//       this.AshaEmployeeRecordList = [];
//       this.AshaEmployeeRecordList = this.ReportAshaEmployeeRecordList.filter(
//         (v) => valueArray.includes(v.p.UnderSupervision)
//       );
//       console.log(
//         "this.AshaEmployeeRecordList on af change:",
//         this.AshaEmployeeRecordList
//       );
//     } else {
//       this.AshaEmployeeRecordList = this.ReportAshaEmployeeRecordList;
//     }

//     // 2️⃣ Build SC list from Asha list (unique)
//     const scMap = new Map<number, any>();
//     this.AshaEmployeeRecordList.forEach((a) => {
//       if (a.p.sc_id && !scMap.has(a.p.sc_id)) {
//         scMap.set(a.p.sc_id, {
//           p: {
//             Ref: a.p.sc_id,
//             Name: a.p.SCName,
//           },
//         });
//       }
//     });
//     this.SCList = Array.from(scMap.values());

//     // 3️⃣ Build Village list from Asha list (unique)
//     const villageMap = new Map<number, any>();
//     this.AshaEmployeeRecordList.forEach((a) => {
//       if (a.p.village_id && !villageMap.has(a.p.village_id)) {
//         villageMap.set(a.p.village_id, {
//           p: {
//             Ref: a.p.village_id,
//             name_en: a.p.VillageNameInEnglish,
//           },
//         });
//       }
//     });
//     this.VillageList = Array.from(villageMap.values());
//   }

//   onSCChanged(e: any) {
//     // Ignore the first time it fires on load
//     if (
//       //// !this.IsNewEntity &&
//       e.previousValue === null ||
//       e.previousValue === undefined ||
//       e.previousValue === 0
//     ) {
//       return;
//     }

//     const valueArray: number[] = Array.isArray(e.value) ? e.value : [e.value];
//     // console.log(valueArray);
//     if (valueArray.length > 0) {
//       this.VillageList = [];
//       this.VillageList = this.ReportVillageList.filter((v) =>
//         valueArray.includes(v.p.sc_id)
//       );
//       if (this.VillageList.length > 0) {
//         this.AshaEmployeeRecordList = this.ReportAshaEmployeeRecordList.filter(
//           (v) => this.VillageList.map((e) => e.p.id).includes(v.p.village_id)
//         );
//       } else {
//         this.AshaEmployeeRecordList = this.ReportAshaEmployeeRecordList;
//       }
//     } else {
//       this.VillageList = this.ReportVillageList;
//     }
//   }

//   onVillageChanged(e: any) {
//     // Ignore the first time it fires on load
//     if (
//       // !this.IsNewEntity &&
//       e.previousValue === null ||
//       e.previousValue === undefined ||
//       e.previousValue === 0
//     ) {
//       return;
//     }

//     const valueArray: number[] = Array.isArray(e.value) ? e.value : [e.value];
//     // console.log(valueArray);
//     if (valueArray.length > 0) {
//       this.AshaEmployeeRecordList = [];
//       this.AshaEmployeeRecordList = this.ReportAshaEmployeeRecordList.filter(
//         (v) => valueArray.includes(v.p.village_id)
//       );
//     } else {
//       this.AshaEmployeeRecordList = this.ReportAshaEmployeeRecordList;
//     }
//   }

//   private sortByName<T>(list: T[], selector: (item: T) => string): T[] {
//   return list.sort((a, b) =>
//     selector(a)?.localeCompare(selector(b), undefined, {
//       sensitivity: 'base'
//     })
//   );
// }

// // To Remove Duplicate names in dropdown //
//   resetFilters() {
//     this.state_id = [];
//     this.zone_id = [];
//     this.district_id = [];
//     this.block_id = [];
//     this.phc_id = [];
//     this.af_post_id = [];
//     this.sc_id = [];
//     this.village_id = [];
//     this.asha_employee_record_id = [];

//     // Optional: Also reset the lists if needed
//     this.DistrictList = [];
//     this.BlockList = [];
//     // ... etc
//   }
// }
